// Generated scene registry. Operational tooling: temp-scripts/print-frame-scenes.
import type { PrintSceneSideWrap } from './print-scene-renderer.js';

interface GeneratedPrintFrameScene {
  /** Immutable asset revision; side geometry is calibrated against these same assets. */
  revision: string;
  sideWrap: PrintSceneSideWrap;
}

export const GENERATED_PRINT_FRAME_SCENES: Record<string, GeneratedPrintFrameScene> = {
  '10-x-10__black-floating-frame': {
    revision: '54ebd210f139ba38',
    sideWrap: {
      inverse: [
        67.7736514315, 0.0033233446, -23.1858967374, 0.5965215314, 2.936620813, -0.9629225174,
        1.2164471572, 0.0001182286, 1,
      ],
      depth: 0.125,
      feather: [0.03916461021383271, 0.0016969617440732174],
    },
  },
  '10-x-10__espresso-floating-frame': {
    revision: '87d7d7d8e2379456',
    sideWrap: {
      inverse: [
        67.7736199858, 0.0033275127, -23.1858880624, 0.596517617, 2.9366184683, -0.9629205423,
        1.2164436256, 0.0001183766, 1,
      ],
      depth: 0.125,
      feather: [0.03916462516404242, 0.0016969617815427193],
    },
  },
  '10-x-10__gallery-wrapped-canvas': {
    revision: '12d35c820c51a886',
    sideWrap: {
      inverse: [
        28.9531054963, 0.0037201596, -4.6102351647, 0.5238112838, 1.4737806784, -0.2386715343,
        1.0540806771, 0.0002659451, 1,
      ],
      depth: 0.125,
      feather: [0.019906701287345275, 0.0010132061322645084],
    },
  },
  '10-x-10__natural-floating-frame': {
    revision: '59e9afb3008836b5',
    sideWrap: {
      inverse: [
        65.984309911, 0.0032247253, -22.6287277989, 0.356817947, 2.7471045367, -0.8276667839,
        0.9603790292, 0.0000931866, 1,
      ],
      depth: 0.125,
      feather: [0.04076100967889649, 0.0016969617754395469],
    },
  },
  '10-x-10__white-floating-frame': {
    revision: 'e2925145cc9adedf',
    sideWrap: {
      inverse: [
        64.1505458204, 0.0031494495, -21.8929470371, 0.5646274339, 2.8884920086, -0.9391041218,
        1.1514148417, 0.0001120421, 1,
      ],
      depth: 0.125,
      feather: [0.037688570959478654, 0.0016969617759787154],
    },
  },
  '10-x-20__black-floating-frame': {
    revision: '8725e968043806e9',
    sideWrap: {
      inverse: [
        111.5209570176, 0.0377332567, -45.9747525931, 0.4758668443, 2.3796729141, -0.6168932013,
        1.2937718225, 0.0008704411, 1,
      ],
      depth: 0.125,
      feather: [0.05989803478763352, 0.0012778908590112103],
    },
  },
  '10-x-20__espresso-floating-frame': {
    revision: 'fb46c0387db28e34',
    sideWrap: {
      inverse: [
        111.5212918224, 0.0377321936, -45.9748900294, 0.4758668544, 2.3796795855, -0.6168943736,
        1.2937821876, 0.0008704209, 1,
      ],
      depth: 0.125,
      feather: [0.05989804465208234, 0.001277890821666899],
    },
  },
  '10-x-20__gallery-wrapped-canvas': {
    revision: 'bdbec14d1f824dd8',
    sideWrap: {
      inverse: [
        59.6496491938, 0.0012693081, -19.4861862807, 0.4685933394, 1.7029710028, -0.3154091408,
        1.1544718155, 0.0000486575, 1,
      ],
      depth: 0.125,
      feather: [0.03539627733496597, 0.0010105335399973002],
    },
  },
  '10-x-20__natural-floating-frame': {
    revision: 'f954e34a465522fd',
    sideWrap: {
      inverse: [
        108.4179494854, 0.0365895008, -44.7858020741, 0.185476778, 2.1748199529, -0.4575069268,
        0.9806608858, 0.0006589551, 1,
      ],
      depth: 0.125,
      feather: [0.0637144054395524, 0.0012778907900819721],
    },
  },
  '10-x-20__white-floating-frame': {
    revision: 'a0de65186e24a5aa',
    sideWrap: {
      inverse: [
        102.0381930646, 0.0345245084, -41.9804309619, 0.435398483, 2.3077203835, -0.5871278561,
        1.1837626633, 0.000796421, 1,
      ],
      depth: 0.125,
      feather: [0.05651300912888252, 0.00127789086763451],
    },
  },
  '10-x-8__black-floating-frame': {
    revision: 'fb38671168c32b31',
    sideWrap: {
      inverse: [
        69.9902669042, 0.0328831374, -23.9589149859, 0.5142436057, 3.7619147424, -1.3272176749,
        1.3222795961, 0.0012307638, 1,
      ],
      depth: 0.125,
      feather: [0.03938510306064505, 0.002116567065897032],
    },
  },
  '10-x-8__espresso-floating-frame': {
    revision: 'ea31b9ab43d830fe',
    sideWrap: {
      inverse: [
        69.9901872952, 0.0328834738, -23.9588879202, 0.5142372776, 3.7619119876, -1.3272146063,
        1.3222765155, 0.001230775, 1,
      ],
      depth: 0.125,
      feather: [0.03938508761503966, 0.0021165670899270083],
    },
  },
  '10-x-8__gallery-wrapped-canvas': {
    revision: 'd44321a114a576b1',
    sideWrap: {
      inverse: [
        24.2444859785, 0.0023758805, -2.2236025016, 0.5170755527, 1.4626947273, -0.2297741261,
        1.1128847062, 0.0002131126, 1,
      ],
      depth: 0.125,
      feather: [0.01749025547941598, 0.0010551280615716675],
    },
  },
  '10-x-8__natural-floating-frame': {
    revision: '0c82a74e6068d16c',
    sideWrap: {
      inverse: [
        74.325124017, 0.0349084533, -25.5047457472, 0.5460979832, 3.8375953859, -1.3617330003,
        1.4041691201, 0.0013065636, 1,
      ],
      depth: 0.125,
      feather: [0.040999886218244595, 0.002116567123480175],
    },
  },
  '10-x-8__white-floating-frame': {
    revision: '66842926315f40d3',
    sideWrap: {
      inverse: [
        66.1330318554, 0.031065278, -22.5834010532, 0.4858981634, 3.6945671041, -1.2965032927,
        1.2494076551, 0.0011627236, 1,
      ],
      depth: 0.125,
      feather: [0.03789269148060716, 0.0021165670898067204],
    },
  },
  '11-x-14__black-floating-frame': {
    revision: '0b9e4bda736791bc',
    sideWrap: {
      inverse: [
        56.3695828963, -0.0032045318, -15.5235180567, 0.4387118675, 1.7861640161, -0.3899693174,
        0.9097645608, -0.0001026029, 1,
      ],
      depth: 0.11363636363636363,
      feather: [0.03695802751062511, 0.0011711102313066094],
    },
  },
  '11-x-14__espresso-floating-frame': {
    revision: 'a8244f4f8c75173b',
    sideWrap: {
      inverse: [
        56.369443091, -0.0032049042, -15.5234793655, 0.4387090489, 1.7861604285, -0.3899679798,
        0.9097557465, -0.0001026141, 1,
      ],
      depth: 0.11363636363636363,
      feather: [0.03695801213035087, 0.0011711102999829989],
    },
  },
  '11-x-14__gallery-wrapped-canvas': {
    revision: 'e87c64ff05f3e384',
    sideWrap: {
      inverse: [
        39.6320337068, 0.0010818215, -9.0498567111, 0.5177708197, 1.5318741744, -0.2701044058,
        1.0169423611, 0.0000548059, 1,
      ],
      depth: 0.11363636363636363,
      feather: [0.026114650248502014, 0.0010093764835405854],
    },
  },
  '11-x-14__natural-floating-frame': {
    revision: '916f60ef747ca609',
    sideWrap: {
      inverse: [
        85.3490761709, 0.0164327305, -29.9870688224, 0.6368617498, 2.4848255321, -0.729379795,
        1.3394541611, 0.000511739, 1,
      ],
      depth: 0.11363636363636363,
      feather: [0.04760069712598292, 0.0013856885841113168],
    },
  },
  '11-x-14__white-floating-frame': {
    revision: '58f39277dc909997',
    sideWrap: {
      inverse: [
        56.3695364049, -0.0032053399, -15.5235048476, 0.4387095172, 1.7861624717, -0.3899684127,
        0.909760836, -0.0001026285, 1,
      ],
      depth: 0.11363636363636363,
      feather: [0.03695802970282358, 0.0011711102624578525],
    },
  },
  '12-x-12__black-floating-frame': {
    revision: '19a7a93c1fde5baf',
    sideWrap: {
      inverse: [
        60.4174820361, 0.0101021654, -18.0547689645, 0.4876391631, 2.2219881359, -0.6074582229,
        0.9914490564, 0.0003288323, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03820060525850746, 0.001404808770307447],
    },
  },
  '12-x-12__espresso-floating-frame': {
    revision: 'c8287445f12f7c4d',
    sideWrap: {
      inverse: [
        60.4174176286, 0.0101003143, -18.0547487982, 0.4876372718, 2.221985388, -0.6074570674,
        0.9914439992, 0.0003287707, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03820061252786215, 0.0014048088172096474],
    },
  },
  '12-x-12__gallery-wrapped-canvas': {
    revision: '6e5ad0db9708c5b2',
    sideWrap: {
      inverse: [
        33.8523095882, 0.0011587637, -5.4733717335, 0.5440531857, 1.458959183, -0.2368446087,
        1.0328478637, 0.00006963, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.023435520513984835, 0.0010099946803603487],
    },
  },
  '12-x-12__natural-floating-frame': {
    revision: '60e8dfd68cf6bf5c',
    sideWrap: {
      inverse: [
        63.6204364206, 0.0106419906, -19.0649382686, 0.5134782537, 2.2504078653, -0.6215125881,
        1.0439954761, 0.0003463994, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03971788395091768, 0.001404808925180009],
    },
  },
  '12-x-12__white-floating-frame': {
    revision: 'c3b84fab42070ad7',
    sideWrap: {
      inverse: [
        60.715414183, 0.0101805846, -18.0940399524, 0.4900406116, 2.3168686472, -0.6274911634,
        1.166904026, 0.0003875682, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03681723539502158, 0.0014048088508919416],
    },
  },
  '12-x-16__black-floating-frame': {
    revision: 'b79a4c141a2378a0',
    sideWrap: {
      inverse: [
        65.724251694, 0.0091896952, -18.2156985173, 0.5353855862, 1.7841099303, -0.4041695704,
        0.9960381775, 0.0002764247, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.0422686350324503, 0.0011473094012581517],
    },
  },
  '12-x-16__espresso-floating-frame': {
    revision: 'c7e0b6d7b64951be',
    sideWrap: {
      inverse: [
        65.7242947676, 0.0091892943, -18.2157102514, 0.5353872091, 1.7841101113, -0.4041700575,
        0.9960386875, 0.0002764126, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.04226865834882159, 0.001147309402514908],
    },
  },
  '12-x-16__gallery-wrapped-canvas': {
    revision: 'fc3bb3be3c8495aa',
    sideWrap: {
      inverse: [
        44.6678575426, -0.0002484683, -10.831830971, 0.4670837799, 1.5144406225, -0.2630064977,
        0.8989068288, -0.0000098998, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.029946410878189403, 0.0010153208995939385],
    },
  },
  '12-x-16__natural-floating-frame': {
    revision: '5ad3680fe77b0ca0',
    sideWrap: {
      inverse: [
        83.2794302281, -0.0003089079, -29.3905445593, 0.4975542473, 2.1528877587, -0.5877559523,
        0.9274758118, -0.0000068422, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.05170322376563361, 0.001336601535746883],
    },
  },
  '12-x-16__white-floating-frame': {
    revision: '10c7c1059f89fae8',
    sideWrap: {
      inverse: [
        62.3115317168, 0.008713281, -17.2179257437, 0.5075857502, 1.7629598946, -0.3930099575,
        0.9443214583, 0.0002620949, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.04055447730455351, 0.0011473093770927125],
    },
  },
  '12-x-18__black-floating-frame': {
    revision: '7ed320a7ead6dc71',
    sideWrap: {
      inverse: [
        86.6055780986, 0.0123053731, -32.0141356251, 0.522616202, 2.055199152, -0.56965039,
        0.8218531052, 0.0002324365, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.054826374842606454, 0.0013009872654060736],
    },
  },
  '12-x-18__espresso-floating-frame': {
    revision: '5d620c741108a404',
    sideWrap: {
      inverse: [
        86.6056496669, 0.0123045269, -32.0141616522, 0.5226192324, 2.0552016529, -0.5696519865,
        0.8218573594, 0.0002324215, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.05482635209307861, 0.0013009872384223658],
    },
  },
  '12-x-18__gallery-wrapped-canvas': {
    revision: '84ede8f68e20f029',
    sideWrap: {
      inverse: [
        51.435776936, -0.0003852498, -14.0160562159, 0.5485845962, 1.6108535525, -0.311555888,
        1.0636526259, -0.0000157686, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03254423552011564, 0.0010192176929480806],
    },
  },
  '12-x-18__natural-floating-frame': {
    revision: '79febbd9f0c2d968',
    sideWrap: {
      inverse: [
        86.6027509452, 0.012299632, -32.0130673848, 0.2972535167, 2.0551325789, -0.4829125584,
        0.8217951877, 0.0002323228, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.054826369565292826, 0.0013009873086669284],
    },
  },
  '12-x-18__white-floating-frame': {
    revision: '720f4d7984f05d48',
    sideWrap: {
      inverse: [
        80.7732074929, 0.011476867, -29.7908439519, 0.2772374111, 2.0218793811, -0.4692469794,
        0.7664705339, 0.00021678, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.051976673749919856, 0.0013009873674898196],
    },
  },
  '12-x-36__black-floating-frame': {
    revision: '2109fb945ca9254c',
    sideWrap: {
      inverse: [
        187.3994408242, 0.0240381062, -83.9513287726, 0.5485722363, 2.3352534297, -0.5761132026,
        1.4968289229, 0.0003824731, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.09273094079492794, 0.0011554596511220807],
    },
  },
  '12-x-36__espresso-floating-frame': {
    revision: '9723116684f47e37',
    sideWrap: {
      inverse: [
        187.3997816746, 0.0240346237, -83.951479708, 0.5485827652, 2.3352570889, -0.576118476,
        1.4968348326, 0.0003824185, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.09273096226587403, 0.0011554596412783982],
    },
  },
  '12-x-36__gallery-wrapped-canvas': {
    revision: '4d52215954ad5601',
    sideWrap: {
      inverse: [
        106.7704192753, 0.0011228639, -41.0181978114, 0.5387958219, 1.7771494596, -0.375790675,
        1.1467301313, 0.0000239899, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.06110160140465294, 0.001017004011911681],
    },
  },
  '12-x-36__natural-floating-frame': {
    revision: 'defce19a298106c1',
    sideWrap: {
      inverse: [
        172.4772535874, 0.0220176657, -77.5511170951, 0.1062878468, 1.7544574609, -0.2930712941,
        0.5804912072, 0.0001479583, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.11359575643923459, 0.0011554596549887583],
    },
  },
  '12-x-36__white-floating-frame': {
    revision: 'c42bdb50d5375229',
    sideWrap: {
      inverse: [
        187.399109384, 0.024037827, -83.9511801774, 0.548586222, 2.3352473534, -0.576118675,
        1.4968192952, 0.0003824669, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.09273101970391939, 0.0011554596727389032],
    },
  },
  '12-x-9__black-floating-frame': {
    revision: 'b616d47933a3d0fa',
    sideWrap: {
      inverse: [
        42.1679367769, 0.008111925, -6.8036467306, 0.562526424, 1.8929281843, -0.4435969459,
        1.1918617198, 0.0004520823, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.02863672482282939, 0.0012853553682399823],
    },
  },
  '12-x-9__espresso-floating-frame': {
    revision: 'a3a8b5d96249da2b',
    sideWrap: {
      inverse: [
        42.1679772758, 0.0081137566, -6.8036541792, 0.562528081, 1.8929297845, -0.4435975356,
        1.1918670685, 0.0004521859, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.028636727451388864, 0.0012853553032075786],
    },
  },
  '12-x-9__gallery-wrapped-canvas': {
    revision: '446675b508a014c6',
    sideWrap: {
      inverse: [
        27.8194967407, -0.0012044853, -2.5495159708, 0.5279908588, 1.5187241361, -0.2611068743,
        1.0818369504, -0.0000918579, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.020271971227565386, 0.0011067225171661047],
    },
  },
  '12-x-9__natural-floating-frame': {
    revision: 'a431bf53efa5eda1',
    sideWrap: {
      inverse: [
        65.6150031231, -0.0163459987, -19.6489994351, 0.4970893678, 3.080186962, -1.0126944459,
        1.1637735786, -0.0005746922, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.03983282482219366, 0.0018700601745735407],
    },
  },
  '12-x-9__white-floating-frame': {
    revision: 'fd6db4a90f0e2c15',
    sideWrap: {
      inverse: [
        42.9784098172, 0.0082878134, -6.9325943791, 0.5733455335, 1.9321432809, -0.4526278547,
        1.3252412825, 0.0005032345, 1,
      ],
      depth: 0.10416666666666667,
      feather: [0.02859505341871445, 0.0012853553432351198],
    },
  },
  '14-x-11__black-floating-frame': {
    revision: 'aa23d8102821707a',
    sideWrap: {
      inverse: [
        49.3047355677, 0.0009916867, -7.5810999547, 0.5792561315, 1.7505108305, -0.3726484241,
        1.2160572563, 0.0000483149, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.03376086561384554, 0.0011986261389947124],
    },
  },
  '14-x-11__espresso-floating-frame': {
    revision: '19fb22203505ee31',
    sideWrap: {
      inverse: [
        49.3046817611, 0.0009894954, -7.5810905841, 0.5792551299, 1.7505092087, -0.372647994,
        1.216051077, 0.0000482079, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.03376086069859167, 0.0011986261987350368],
    },
  },
  '14-x-11__gallery-wrapped-canvas': {
    revision: 'e8e2a67370fcfa08',
    sideWrap: {
      inverse: [
        32.0284000532, 0.0033262991, -2.9909854724, 0.5195482992, 1.4286432092, -0.2154768966,
        1.0598081872, 0.0002164902, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.023481906348466364, 0.0010473430793784464],
    },
  },
  '14-x-11__natural-floating-frame': {
    revision: 'ed10b18dea306be7',
    sideWrap: {
      inverse: [
        75.015792368, 0.0166973662, -21.4815931358, 0.4574219991, 2.8635278346, -0.8666483122,
        1.3379707896, 0.0005903213, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.04438638923635609, 0.0016941568558887716],
    },
  },
  '14-x-11__white-floating-frame': {
    revision: '48437250f1f0eff9',
    sideWrap: {
      inverse: [
        47.3589354679, 0.0009527642, -7.2424479086, 0.5563958122, 1.7381924525, -0.366674249,
        1.1680697077, 0.0000464187, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.032658302014757105, 0.0011986260896888993],
    },
  },
  '14-x-14__black-floating-frame': {
    revision: 'e1372be72cd69fec',
    sideWrap: {
      inverse: [
        57.2705292772, -0.0167425991, -12.2331853217, 0.5409579394, 1.741118771, -0.377535667,
        1.0345238286, -0.0005994094, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.03838663455210735, 0.0011672178852998867],
    },
  },
  '14-x-14__espresso-floating-frame': {
    revision: 'e8dd33afe0700ac0',
    sideWrap: {
      inverse: [
        57.2706306411, -0.0167377702, -12.2332094086, 0.540958315, 1.7411204374, -0.3775360075,
        1.0345284597, -0.0005992381, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.0383866667013013, 0.0011672178565647975],
    },
  },
  '14-x-14__gallery-wrapped-canvas': {
    revision: '48ac696dcbce7783',
    sideWrap: {
      inverse: [
        39.5191877012, 0.0014961309, -6.5214160998, 0.5188152824, 1.447375391, -0.2279568744,
        1.0100245242, 0.0000754984, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.027505940535067386, 0.0010073684645919786],
    },
  },
  '14-x-14__natural-floating-frame': {
    revision: '8e4f644db66bee5f',
    sideWrap: {
      inverse: [
        73.1195095242, 0.0025119447, -20.9317123569, 0.5034779014, 2.1883991255, -0.5619027933,
        1.2129382608, 0.0000826474, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.044477616997778524, 0.001331148664903686],
    },
  },
  '14-x-14__white-floating-frame': {
    revision: '1ab364b35ffbaec0',
    sideWrap: {
      inverse: [
        57.2707571668, -0.0167418427, -12.2332344125, 0.5409655304, 1.7411239633, -0.3775381323,
        1.034540151, -0.0005993893, 1,
      ],
      depth: 0.08928571428571429,
      feather: [0.03838666893774972, 0.0011672177597950321],
    },
  },
  '15-x-30__gallery-wrapped-canvas': {
    revision: 'fab5d6ad60a69d21',
    sideWrap: {
      inverse: [
        89.7890673262, 0.0121866382, -29.2623406094, 0.3895264213, 1.7209530835, -0.2870449077,
        1.2098707134, 0.0003262126, 1,
      ],
      depth: 0.08333333333333333,
      feather: [0.0529391583818915, 0.0010145684076379629],
    },
  },
  '16-x-12__black-floating-frame': {
    revision: 'e9a33485b373194b',
    sideWrap: {
      inverse: [
        54.714698125, 0.0057755731, -8.0049179765, 0.6252600165, 1.796265239, -0.3940967563,
        1.3291338549, 0.0002771938, 1,
      ],
      depth: 0.078125,
      feather: [0.037243324277081304, 0.0012225914600114494],
    },
  },
  '16-x-12__espresso-floating-frame': {
    revision: 'd8fe4c91cc66ff86',
    sideWrap: {
      inverse: [
        54.7147876091, 0.0057842864, -8.0049354284, 0.62525868, 1.7962669193, -0.3940968499,
        1.3291389153, 0.0002776126, 1,
      ],
      depth: 0.078125,
      feather: [0.03724335369281487, 0.0012225914272355645],
    },
  },
  '16-x-12__gallery-wrapped-canvas': {
    revision: '7b0c9a9af91fe479',
    sideWrap: {
      inverse: [
        37.4529933819, 0.0046945041, -3.404331021, 0.571618812, 1.4946609423, -0.2444412575,
        1.2308747838, 0.0003034959, 1,
      ],
      depth: 0.078125,
      feather: [0.02714603297717291, 0.0010832242445973873],
    },
  },
  '16-x-12__natural-floating-frame': {
    revision: '3cac45e9bf59c997',
    sideWrap: {
      inverse: [
        81.4382906393, 0.0507283964, -22.5225985022, 0.2869850146, 2.7355631085, -0.7826685489,
        1.15323609, 0.0014266348, 1,
      ],
      depth: 0.078125,
      feather: [0.05071549924997218, 0.0017031191465170803],
    },
  },
  '16-x-12__white-floating-frame': {
    revision: '86027c08217b30dd',
    sideWrap: {
      inverse: [
        54.7148019188, 0.0057859606, -8.0049383599, 0.6252582068, 1.7962668251, -0.3940967638,
        1.3291381238, 0.0002776927, 1,
      ],
      depth: 0.078125,
      feather: [0.03724336661020173, 0.0012225914400952594],
    },
  },
  '16-x-16__black-floating-frame': {
    revision: '03664f1bba1ae1ff',
    sideWrap: {
      inverse: [
        74.9502980382, 0.0012615235, -20.5807328235, 0.5855503012, 2.0685743925, -0.5306388524,
        1.1906598529, 0.0000397627, 1,
      ],
      depth: 0.078125,
      feather: [0.04632135985054478, 0.0012784239722938226],
    },
  },
  '16-x-16__espresso-floating-frame': {
    revision: '1488b5713270e0b6',
    sideWrap: {
      inverse: [
        74.950231519, 0.0012645895, -20.5807160899, 0.5855467566, 2.0685734686, -0.5306376942,
        1.1906574514, 0.0000398593, 1,
      ],
      depth: 0.078125,
      feather: [0.04632134092921102, 0.0012784239838500547],
    },
  },
  '16-x-16__gallery-wrapped-canvas': {
    revision: '70ab6befdc5f35f3',
    sideWrap: {
      inverse: [
        45.4095274665, -0.0006022222, -7.6814768135, 0.4889601592, 1.4529370631, -0.2265626565,
        0.9902708125, -0.0000259796, 1,
      ],
      depth: 0.078125,
      feather: [0.03170518012575249, 0.0010144576647451624],
    },
  },
  '16-x-16__natural-floating-frame': {
    revision: '7810362b9a39ed87',
    sideWrap: {
      inverse: [
        80.491630362, 0.0013512917, -22.236486756, 0.4230379709, 2.0157026593, -0.4739071141,
        1.0728783225, 0.0000357829, 1,
      ],
      depth: 0.078125,
      feather: [0.05105085657903674, 0.001278424007739625],
    },
  },
  '16-x-16__white-floating-frame': {
    revision: '7e59c8e0de477bbe',
    sideWrap: {
      inverse: [
        70.9706538561, 0.0011948421, -19.4879545541, 0.3729942318, 1.958736475, -0.4493701743,
        0.9459706806, 0.0000316399, 1,
      ],
      depth: 0.078125,
      feather: [0.046321352607820346, 0.0012784240264916043],
    },
  },
  '16-x-20__black-floating-frame': {
    revision: 'e06d7a9a0b028bd7',
    sideWrap: {
      inverse: [
        81.6672905434, 0.0097033505, -21.7487809336, 0.6063657735, 1.726080522, -0.397066847,
        0.9743341743, 0.0002301492, 1,
      ],
      depth: 0.078125,
      feather: [0.05338776037843964, 0.0011283028651139083],
    },
  },
  '16-x-20__espresso-floating-frame': {
    revision: 'a373ccddaba221e3',
    sideWrap: {
      inverse: [
        86.1428854884, 0.0102600758, -22.9406786554, 0.6396122186, 1.8206986484, -0.4188348083,
        1.2221140404, 0.000289055, 1,
      ],
      depth: 0.078125,
      feather: [0.05338773442390124, 0.0011283028303187724],
    },
  },
  '16-x-20__gallery-wrapped-canvas': {
    revision: '32c43139ce846561',
    sideWrap: {
      inverse: [
        54.5188590382, 0.0026574777, -12.7678314781, 0.4530242304, 1.4613205913, -0.2456550404,
        0.7934555018, 0.0000767897, 1,
      ],
      depth: 0.078125,
      feather: [0.03775476661936807, 0.0010119501891819674],
    },
  },
  '16-x-20__natural-floating-frame': {
    revision: '0fe463e883346274',
    sideWrap: {
      inverse: [
        91.5452552537, -0.0267568961, -29.853283788, 0.3487853064, 1.9092605434, -0.4383595595,
        0.7866042997, -0.0004578397, 1,
      ],
      depth: 0.078125,
      feather: [0.06019709425355127, 0.0012556163391690043],
    },
  },
  '16-x-20__white-floating-frame': {
    revision: 'c974a72d8b62dd45',
    sideWrap: {
      inverse: [
        86.0303098851, 0.0102479221, -22.9093935842, 0.6387662901, 1.8200854632, -0.4185160785,
        1.2205081731, 0.0002887105, 1,
      ],
      depth: 0.078125,
      feather: [0.05333592668967328, 0.0011283028880799345],
    },
  },
  '16-x-24__black-floating-frame': {
    revision: '51c611f3f6ec730b',
    sideWrap: {
      inverse: [
        123.5349964259, 0.0029905399, -44.1137797966, 0.4993894532, 2.153569104, -0.5213986559,
        1.2938808983, 0.0000623167, 1,
      ],
      depth: 0.078125,
      feather: [0.06967440101218338, 0.0012146069381079002],
    },
  },
  '16-x-24__espresso-floating-frame': {
    revision: '0202884563d1e785',
    sideWrap: {
      inverse: [
        123.5343638717, 0.0029884491, -44.1135528794, 0.4993835036, 2.1535594857, -0.5213949758,
        1.2938629016, 0.0000622726, 1,
      ],
      depth: 0.078125,
      feather: [0.06967435794406927, 0.0012146069943206523],
    },
  },
  '16-x-24__gallery-wrapped-canvas': {
    revision: '43f83af66dfd2b2e',
    sideWrap: {
      inverse: [
        68.1145324892, 0.0037359667, -18.9036519524, 0.514825794, 1.5970829497, -0.2962282196,
        1.0501194965, 0.0001143066, 1,
      ],
      depth: 0.078125,
      feather: [0.04327412276710349, 0.001014612995640151],
    },
  },
  '16-x-24__natural-floating-frame': {
    revision: '65106dd6e70c1af6',
    sideWrap: {
      inverse: [
        111.2248679865, 0.0026891341, -39.7179540742, 0.4496182935, 1.938869116, -0.4694235824,
        0.8947672264, 0.0000430924, 1,
      ],
      depth: 0.078125,
      feather: [0.06967772776394549, 0.0012146069091834523],
    },
  },
  '16-x-24__white-floating-frame': {
    revision: 'e2aceaf417acaf8d',
    sideWrap: {
      inverse: [
        124.5079465515, 0.0030184089, -44.3574638632, 0.8057830648, 2.3217689645, -0.660802146,
        1.6065419923, 0.0000773913, 1,
      ],
      depth: 0.078125,
      feather: [0.0651359943809651, 0.0012146068899322236],
    },
  },
  '16-x-32__black-floating-frame': {
    revision: 'ea509b1d02037452',
    sideWrap: {
      inverse: [
        189.034011807, 0.0444748526, -75.3995062414, 0.6852229538, 2.4313307695, -0.623925577,
        1.8188707346, 0.0008517679, 1,
      ],
      depth: 0.078125,
      feather: [0.09040736490721546, 0.0011626037436218955],
    },
  },
  '16-x-32__espresso-floating-frame': {
    revision: 'f213842992c502d2',
    sideWrap: {
      inverse: [
        189.0349816554, 0.0444789084, -75.3998949919, 0.6852309978, 2.4313431004, -0.6239305893,
        1.8188923746, 0.0008518513, 1,
      ],
      depth: 0.078125,
      feather: [0.09040736874323135, 0.001162603705560317],
    },
  },
  '16-x-32__natural-floating-frame': {
    revision: '800c769c115285fd',
    sideWrap: {
      inverse: [
        184.9722007287, 0.0434206163, -73.9334402877, 0.2403129395, 2.1639384813, -0.4045121168,
        1.3496233623, 0.0006313426, 1,
      ],
      depth: 0.078125,
      feather: [0.09939323235700817, 0.001162603795262371],
    },
  },
  '16-x-32__white-floating-frame': {
    revision: '9565f51a131f9fb1',
    sideWrap: {
      inverse: [
        189.0338953666, 0.0444733328, -75.3994590528, 0.6852256422, 2.4313318721, -0.6239268206,
        1.8188727169, 0.0008517402, 1,
      ],
      depth: 0.078125,
      feather: [0.09040726695225085, 0.0011626037340464641],
    },
  },
  '16-x-48__black-floating-frame': {
    revision: 'c61bbd2d76336344',
    sideWrap: {
      inverse: [
        284.5745555055, 0.0130973719, -109.9234631291, 0.7562787775, 2.3852904686, -0.555998737,
        2.2137829014, 0.0002029848, 1,
      ],
      depth: 0.078125,
      feather: [0.12683559220555793, 0.0010630846432067719],
    },
  },
  '16-x-48__espresso-floating-frame': {
    revision: '03aea0e46dbfbf7a',
    sideWrap: {
      inverse: [
        284.574579538, 0.0130913086, -109.9234693832, 0.7562703457, 2.3852916452, -0.5559955761,
        2.213785452, 0.000202891, 1,
      ],
      depth: 0.078125,
      feather: [0.1268355373287727, 0.0010630846387996973],
    },
  },
  '16-x-48__gallery-wrapped-canvas': {
    revision: '5908b234a4e077e9',
    sideWrap: {
      inverse: [
        143.7899082697, 0.0026981829, -53.8028187762, 0.6472945883, 1.8025138015, -0.3995489246,
        1.3074609629, 0.0000488453, 1,
      ],
      depth: 0.078125,
      feather: [0.07972919206966059, 0.000999451376616375],
    },
  },
  '16-x-48__natural-floating-frame': {
    revision: 'ae3b0756e47da0a2',
    sideWrap: {
      inverse: [
        319.1099630637, 0.0812957756, -142.1774294674, 0.2992789156, 2.3240632232, -0.4275608405,
        1.6393729815, 0.000833188, 1,
      ],
      depth: 0.078125,
      feather: [0.15287810339938188, 0.00111320425403853],
    },
  },
  '16-x-48__white-floating-frame': {
    revision: '6d56675efe4b7c5e',
    sideWrap: {
      inverse: [
        230.0253007155, 0.0105834859, -88.6608702357, 0.6113099916, 2.172597192, -0.475963359,
        1.7894305749, 0.0001640242, 1,
      ],
      depth: 0.078125,
      feather: [0.11255911105938297, 0.0010630846467832838],
    },
  },
  '18-x-12__black-floating-frame': {
    revision: 'ab12d2ad1cb85451',
    sideWrap: {
      inverse: [
        79.7218521951, -0.0141764661, -21.1524244661, 0.5573345425, 2.8846119461, -0.9493120487,
        1.0554918275, -0.0003728994, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.05121681946004726, 0.0018533211208371213],
    },
  },
  '18-x-12__espresso-floating-frame': {
    revision: 'a42e49ad4079393b',
    sideWrap: {
      inverse: [
        79.739664114, -0.01417927, -21.157370839, 0.5574561198, 2.8847641852, -0.9493881241,
        1.055735309, -0.0003729759, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.051225556144278386, 0.001853321031261793],
    },
  },
  '18-x-12__gallery-wrapped-canvas': {
    revision: '977e45a2ca662d11',
    sideWrap: {
      inverse: [
        40.2380992375, -0.0043744611, -3.6862983582, 0.5107087982, 1.6303067439, -0.3208269873,
        0.9537989983, -0.0002049259, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.030107718253926948, 0.0012199358064226835],
    },
  },
  '18-x-12__natural-floating-frame': {
    revision: 'b6c6117870e440f5',
    sideWrap: {
      inverse: [
        85.3953648157, -0.015177726, -22.7289317616, 0.5969934308, 2.9316313733, -0.9733971243,
        1.1306151476, -0.0003992395, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.05398163568598445, 0.001853321032994004],
    },
  },
  '18-x-12__white-floating-frame': {
    revision: '5270ca8e1399311d',
    sideWrap: {
      inverse: [
        74.755397013, -0.0132950009, -19.7723887794, 0.5226167542, 2.8434548121, -0.9282288805,
        0.9897345356, -0.0003497122, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.04872145141878353, 0.0018533211605908464],
    },
  },
  '18-x-24__black-floating-frame': {
    revision: 'e43a3bf385e577fc',
    sideWrap: {
      inverse: [
        96.5283487427, 0.0229209777, -26.6774039325, 0.3943242297, 1.7122379783, -0.3291850281,
        0.9779421003, 0.0004620846, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.06267881633380562, 0.0011116584038158882],
    },
  },
  '18-x-24__espresso-floating-frame': {
    revision: '18dcdfc89735bd08',
    sideWrap: {
      inverse: [
        96.5285060184, 0.0229187196, -26.6774462528, 0.3943314385, 1.7122394382, -0.3291872482,
        0.9779460941, 0.0004620402, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.06267886341410744, 0.0011116583899518206],
    },
  },
  '18-x-24__gallery-wrapped-canvas': {
    revision: 'ae2b7e2b1995b400',
    sideWrap: {
      inverse: [
        66.8256901753, 0.0049859523, -16.8202941988, 0.4646411957, 1.5063761187, -0.2599659481,
        0.8817889255, 0.0001307146, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.04497052617168512, 0.001013675850476507],
    },
  },
  '18-x-24__natural-floating-frame': {
    revision: 'e24625afaea2cdb7',
    sideWrap: {
      inverse: [
        111.5462689561, -0.0141018325, -37.0362817481, 0.5525359057, 1.9153855145, -0.4860177404,
        0.9332177145, -0.0002349716, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.07037598635833957, 0.0012085155924393806],
    },
  },
  '18-x-24__white-floating-frame': {
    revision: 'b9ef991866a5c6ce',
    sideWrap: {
      inverse: [
        89.3417515496, 0.0212123006, -24.6168016216, 0.3649660488, 1.6840777166, -0.3171463095,
        0.905135211, 0.0004276382, 1,
      ],
      depth: 0.06944444444444445,
      feather: [0.058981919484450376, 0.0011116584029834356],
    },
  },
  '20-x-10__black-floating-frame': {
    revision: '3f86cb45f27aef68',
    sideWrap: {
      inverse: [
        80.3319363491, -0.0190841447, -20.7094086567, 0.3965427393, 3.436959625, -1.2293705889,
        0.7009305675, -0.0003315828, 1,
      ],
      depth: 0.0625,
      feather: [0.05620742217393706, 0.0024049208468293294],
    },
  },
  '20-x-10__espresso-floating-frame': {
    revision: 'b78935c3efc71479',
    sideWrap: {
      inverse: [
        101.761187677, -0.024411806, -26.2337074338, 0.9917107668, 4.3535572914, -1.690693818,
        1.8668165227, -0.00088746, 1,
      ],
      depth: 0.0625,
      feather: [0.05620752501980378, 0.002404920819436672],
    },
  },
  '20-x-10__gallery-wrapped-canvas': {
    revision: 'a6e4ba564d1779ba',
    sideWrap: {
      inverse: [
        43.6305025744, -0.0025123404, -4.107280689, 0.4235081252, 2.148000517, -0.5759518602,
        0.8445557165, -0.0000963214, 1,
      ],
      depth: 0.0625,
      feather: [0.033029729086424736, 0.0016261436730659064],
    },
  },
  '20-x-10__natural-floating-frame': {
    revision: '0049de8c2504259f',
    sideWrap: {
      inverse: [
        86.0965814383, -0.020441215, -22.2672757082, 0.4250134775, 3.4765282653, -1.2500428905,
        0.7512615325, -0.0003551767, 1,
      ],
      depth: 0.0625,
      feather: [0.05955506315915988, 0.0024049203945756973],
    },
  },
  '20-x-10__white-floating-frame': {
    revision: '0d34d658362c7095',
    sideWrap: {
      inverse: [
        89.7889897717, -0.0214224291, -23.1473897362, 0.4432272402, 3.8414579464, -1.3740601265,
        1.2153749449, -0.000576013, 1,
      ],
      depth: 0.0625,
      feather: [0.056207609693698694, 0.002404920479341209],
    },
  },
  '20-x-16__black-floating-frame': {
    revision: '61e5b1d37f49eeaf',
    sideWrap: {
      inverse: [
        65.7348528907, -0.0024753634, -8.9003563033, 0.5267606864, 1.5920993168, -0.2837322584,
        1.2428419362, -0.0000927178, 1,
      ],
      depth: 0.0625,
      feather: [0.04600298615907309, 0.0011142256395291373],
    },
  },
  '20-x-16__espresso-floating-frame': {
    revision: '78a441289b054344',
    sideWrap: {
      inverse: [
        65.7349153248, -0.0024770113, -8.9003639335, 0.5267629683, 1.59210047, -0.2837327328,
        1.2428482248, -0.0000927799, 1,
      ],
      depth: 0.0625,
      feather: [0.04600299383089727, 0.0011142255958545633],
    },
  },
  '20-x-16__gallery-wrapped-canvas': {
    revision: 'd924046730f108c0',
    sideWrap: {
      inverse: [
        45.3907675581, 0.0012636405, -4.312754915, 0.5026186376, 1.3954236114, -0.1906955459,
        1.1569260665, 0.0000635949, 1,
      ],
      depth: 0.0625,
      feather: [0.033210440337246745, 0.0010209471498864012],
    },
  },
  '20-x-16__natural-floating-frame': {
    revision: '2156774f27827c00',
    sideWrap: {
      inverse: [
        112.7984797863, 0.0762006084, -29.2244960844, 0.5116302545, 2.8498825566, -0.7737264693,
        2.1276115937, 0.0028478529, 1,
      ],
      depth: 0.0625,
      feather: [0.05943389310092687, 0.0015008580725766804],
    },
  },
  '20-x-16__white-floating-frame': {
    revision: '158e337a729153d2',
    sideWrap: {
      inverse: [
        62.3210011171, -0.0023501128, -8.3861923675, 0.4994074764, 1.578855168, -0.2778454529,
        1.1782995325, -0.0000880266, 1,
      ],
      depth: 0.0625,
      feather: [0.04397978897934211, 0.0011142256110741955],
    },
  },
  '20-x-20__black-floating-frame': {
    revision: '17fcdd7a528cd7bf',
    sideWrap: {
      inverse: [
        90.6408846775, 0.0274148393, -23.3914853406, 0.6073793741, 1.9428463367, -0.4631780971,
        1.2688739668, 0.0007621866, 1,
      ],
      depth: 0.0625,
      feather: [0.05609708910484901, 0.0012021797100013058],
    },
  },
  '20-x-20__espresso-floating-frame': {
    revision: '6a234def2a114473',
    sideWrap: {
      inverse: [
        90.6408650904, 0.0274113816, -23.3914785634, 0.6073852872, 1.9428457847, -0.4631795729,
        1.2688728361, 0.00076209, 1,
      ],
      depth: 0.0625,
      feather: [0.056097091795279164, 0.001202179715760614],
    },
  },
  '20-x-20__gallery-wrapped-canvas': {
    revision: '30f21ab9bcc6c4aa',
    sideWrap: {
      inverse: [
        56.0205963997, 0.001964825, -9.6645355978, 0.4623797263, 1.4527366794, -0.2208806455,
        0.991034086, 0.0000689027, 1,
      ],
      depth: 0.0625,
      feather: [0.039161811062528945, 0.0010155273771584661],
    },
  },
  '20-x-20__natural-floating-frame': {
    revision: 'c8a6169f12102dbc',
    sideWrap: {
      inverse: [
        98.0465878171, 0.0296515982, -25.3843620984, 0.6570142227, 1.9837151191, -0.4829789883,
        1.3725409523, 0.0008243703, 1,
      ],
      depth: 0.0625,
      feather: [0.05943097958750268, 0.0012021797355890086],
    },
  },
  '20-x-20__white-floating-frame': {
    revision: '1a2c495e13c4f0dd',
    sideWrap: {
      inverse: [
        90.6407690092, 0.0274110082, -23.3914535955, 0.6073817013, 1.9428449783, -0.4631784978,
        1.2688707576, 0.0007620792, 1,
      ],
      depth: 0.0625,
      feather: [0.056097055690786234, 0.0012021797206548022],
    },
  },
  '20-x-24__black-floating-frame': {
    revision: '7d57f5492aaa0e39',
    sideWrap: {
      inverse: [
        96.7169563365, 0.0156173164, -29.6273692754, 0.3172120841, 1.7394589622, -0.3680298458,
        0.6402205408, 0.0002060742, 1,
      ],
      depth: 0.0625,
      feather: [0.06693357592854234, 0.0012037321518255258],
    },
  },
  '20-x-24__espresso-floating-frame': {
    revision: '1aa72f2ef7da2cbf',
    sideWrap: {
      inverse: [
        96.7167083667, 0.0156111309, -29.6272902456, 0.3172162062, 1.7394559556, -0.3680306641,
        0.6402141129, 0.0002059911, 1,
      ],
      depth: 0.0625,
      feather: [0.06693352007915368, 0.0012037321817291173],
    },
  },
  '20-x-24__gallery-wrapped-canvas': {
    revision: '5b616c8bf920ab1c',
    sideWrap: {
      inverse: [
        65.8214363912, 0.0047685011, -14.9767625044, 0.3828907658, 1.4586097405, -0.227334673,
        0.7872390385, 0.0001133826, 1,
      ],
      depth: 0.0625,
      feather: [0.045961096654668916, 0.0010184629915936617],
    },
  },
  '20-x-24__natural-floating-frame': {
    revision: '98e9a25073e3c923',
    sideWrap: {
      inverse: [
        96.716830169, 0.0156113643, -29.6273276641, 0.3172176147, 1.739457274, -0.3680313073,
        0.6402170201, 0.0002059948, 1,
      ],
      depth: 0.0625,
      feather: [0.06693355298522914, 0.001203732168611094],
    },
  },
  '20-x-24__white-floating-frame': {
    revision: '7f50e756044e1c38',
    sideWrap: {
      inverse: [
        89.5038092052, 0.0144448263, -27.3431707603, 0.2935752946, 1.7174680849, -0.3571208705,
        0.5924925852, 0.0001906093, 1,
      ],
      depth: 0.0625,
      feather: [0.06273454660298675, 0.0012037320192807926],
    },
  },
  '20-x-30__black-floating-frame': {
    revision: '844fcd58ae4e189a',
    sideWrap: {
      inverse: [
        106.6604588269, 0.0180305691, -31.1627509549, 0.3227045931, 1.6194129486, -0.28711208,
        0.7964750947, 0.0002682792, 1,
      ],
      depth: 0.0625,
      feather: [0.07156289868569884, 0.00108644082139439],
    },
  },
  '20-x-30__espresso-floating-frame': {
    revision: '7f1bf1ebbb69e3d1',
    sideWrap: {
      inverse: [
        106.6604423322, 0.0180376295, -31.1627496642, 0.3226988894, 1.6194121525, -0.2871102941,
        0.7964727645, 0.0002683835, 1,
      ],
      depth: 0.0625,
      feather: [0.07156292584808331, 0.001086440832636072],
    },
  },
  '20-x-30__gallery-wrapped-canvas': {
    revision: '02d5229e1c22dfba',
    sideWrap: {
      inverse: [
        86.4269329499, 0.0061858547, -24.2026371298, 0.545265178, 1.5938219871, -0.3049048404,
        1.039189302, 0.0001478618, 1,
      ],
      depth: 0.0625,
      feather: [0.055115244818007524, 0.0010163477078672508],
    },
  },
  '20-x-30__natural-floating-frame': {
    revision: 'ffb027a0cec4919d',
    sideWrap: {
      inverse: [
        143.1381894246, 0.0150184766, -50.0462272257, 0.4387106339, 1.8503997106, -0.4198643336,
        0.9028328953, 0.0001888584, 1,
      ],
      depth: 0.0625,
      feather: [0.09008792075821188, 0.0011645400459175492],
    },
  },
  '20-x-30__white-floating-frame': {
    revision: '8a3ca64b7dcf7a29',
    sideWrap: {
      inverse: [
        106.6600130268, 0.0180325402, -31.1626217291, 0.3226980699, 1.619408303, -0.2871095933,
        0.7964630843, 0.0002683056, 1,
      ],
      depth: 0.0625,
      feather: [0.07156280839347173, 0.0010864408657638624],
    },
  },
  '20-x-40__gallery-wrapped-canvas': {
    revision: '7e25b8bd48b379bf',
    sideWrap: {
      inverse: [
        131.8590357479, 0.0133977881, -43.0806360245, 0.6123819682, 1.8758740422, -0.3763780565,
        1.5896643461, 0.0003210976, 1,
      ],
      depth: 0.0625,
      feather: [0.07144613457871593, 0.0010163312721319596],
    },
  },
  '20-x-60__black-floating-frame': {
    revision: '9d74081ffcd230ec',
    sideWrap: {
      inverse: [
        277.3790324957, 0.0328865529, -122.6410531462, 0.1248757627, 1.8672893914, -0.2741616985,
        0.9632192535, 0.0002280106, 1,
      ],
      depth: 0.0625,
      feather: [0.1615441069081784, 0.0010874331455047951],
    },
  },
  '20-x-60__espresso-floating-frame': {
    revision: '9dc7b857ae21ecf2',
    sideWrap: {
      inverse: [
        277.378242779, 0.0328811284, -122.6407013203, 0.124879296, 1.8672849913, -0.2741627538,
        0.9632117443, 0.0002279718, 1,
      ],
      depth: 0.0625,
      feather: [0.16154402738371768, 0.001087433154883184],
    },
  },
  '20-x-60__gallery-wrapped-canvas': {
    revision: 'fa7ef2fef1368211',
    sideWrap: {
      inverse: [
        201.8430937341, 0.0091117457, -78.7233584399, 0.5456559445, 1.9328261071, -0.3929360056,
        1.4641319664, 0.0001317109, 1,
      ],
      depth: 0.0625,
      feather: [0.10628579085442323, 0.001017745721520893],
    },
  },
  '20-x-60__natural-floating-frame': {
    revision: 'd701ce79e5b25c7b',
    sideWrap: {
      inverse: [
        360.7692133983, 0.0427573144, -159.8120274494, 0.162418606, 2.0363512533, -0.3107192936,
        1.2527863649, 0.0002964455, 1,
      ],
      depth: 0.0625,
      feather: [0.19266862662808168, 0.0010874331464193903],
    },
  },
  '20-x-60__white-floating-frame': {
    revision: 'b84ecf48513a4ab6',
    sideWrap: {
      inverse: [
        277.3796138294, 0.0328782552, -122.6413060046, 0.124876877, 1.8672941995, -0.2741627557,
        0.9632276157, 0.0002279545, 1,
      ],
      depth: 0.0625,
      feather: [0.1615440252200208, 0.0010874331330732745],
    },
  },
  '24-x-16__black-floating-frame': {
    revision: 'aedbb7b5326f93e5',
    sideWrap: {
      inverse: [
        96.6447869822, 0.0039805149, -23.7202300332, 0.4586284269, 2.5636045979, -0.780962191,
        0.9152608774, 0.0000750368, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06514032442327145, 0.0017278903117484911],
    },
  },
  '24-x-16__espresso-floating-frame': {
    revision: '33f72eac5fa0c7e1',
    sideWrap: {
      inverse: [
        96.6446347324, 0.003981214, -23.7201930179, 0.4586300561, 2.5636014383, -0.7809617828,
        0.9152548093, 0.0000750496, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06514030381943577, 0.0017278903533020377],
    },
  },
  '24-x-16__gallery-wrapped-canvas': {
    revision: 'da523f1ece802af2',
    sideWrap: {
      inverse: [
        51.6304367827, 0.0004487269, -4.560913432, 0.4594181482, 1.5797553652, -0.29491305,
        0.843541259, 0.0000145429, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.039387261696079465, 0.0012051409142997253],
    },
  },
  '24-x-16__natural-floating-frame': {
    revision: '81526e07bf94dd37',
    sideWrap: {
      inverse: [
        105.1101550569, 0.0043335843, -25.8855406283, 0.4988004011, 2.6065374223, -0.8024308989,
        0.9954317257, 0.0000816926, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06967928511432439, 0.0017278903054105668],
    },
  },
  '24-x-16__white-floating-frame': {
    revision: '2d7e873afbd17d8a',
    sideWrap: {
      inverse: [
        96.6385441947, 0.0039760162, -23.7186292227, 0.4586027415, 2.5635753044, -0.7809479545,
        0.9152065498, 0.0000749524, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06513685828618151, 0.0017278902686907742],
    },
  },
  '24-x-18__black-floating-frame': {
    revision: 'd54b1a889ca420f8',
    sideWrap: {
      inverse: [
        80.1980307349, -0.0239368845, -10.3803641058, 0.5490258684, 1.6807008087, -0.3210013065,
        1.3946678899, -0.000825279, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0556358846922338, 0.0011662414783147558],
    },
  },
  '24-x-18__espresso-floating-frame': {
    revision: 'ebf14cc8f948a034',
    sideWrap: {
      inverse: [
        80.1981104917, -0.0239364202, -10.3803746741, 0.5490246009, 1.6807027539, -0.3210014194,
        1.3946778522, -0.0008252681, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.05563587282697783, 0.0011662414154325353],
    },
  },
  '24-x-18__gallery-wrapped-canvas': {
    revision: 'f058c6e652ef50c3',
    sideWrap: {
      inverse: [
        52.4793175583, 0.0002021223, -4.6795069541, 0.4620630551, 1.4358258363, -0.2130268708,
        1.0459723593, 0.0000079768, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.039204527104408395, 0.001072626684004034],
    },
  },
  '24-x-18__natural-floating-frame': {
    revision: '6599a4474d3ef8e1',
    sideWrap: {
      inverse: [
        110.4925472541, 0.0104258555, -27.2139953895, 0.5447160469, 2.4670319594, -0.7038428395,
        1.3158710364, 0.0002468483, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0687086105772391, 0.0015340206412299583],
    },
  },
  '24-x-18__white-floating-frame': {
    revision: '976408a6a042f722',
    sideWrap: {
      inverse: [
        80.1980057989, -0.0239374796, -10.3803605777, 0.5490207412, 1.6807004253, -0.321000547,
        1.394666013, -0.0008252987, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.055635880261925744, 0.0011662414889261209],
    },
  },
  '24-x-20__black-floating-frame': {
    revision: 'babbc864dab92a8a',
    sideWrap: {
      inverse: [
        105.5384982171, 0.0470180539, -25.9243608357, 0.4836262469, 2.245931752, -0.5701116584,
        1.3764207181, 0.0012184591, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0648572328543599, 0.0013798311664399417],
    },
  },
  '24-x-20__espresso-floating-frame': {
    revision: '7319eaa5a86579dd',
    sideWrap: {
      inverse: [
        105.5378425413, 0.0470173236, -25.9241995587, 0.4836149085, 2.2459188927, -0.5701062355,
        1.3763901832, 0.0012184208, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06485720760938711, 0.0013798313111240714],
    },
  },
  '24-x-20__gallery-wrapped-canvas': {
    revision: '66d9a241ecbe9fff',
    sideWrap: {
      inverse: [
        57.2900892843, -0.0008825045, -6.4924352209, 0.5035991652, 1.4130166853, -0.1993173715,
        1.1430375367, -0.0000348637, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.04142369656449885, 0.0010216967382699104],
    },
  },
  '24-x-20__natural-floating-frame': {
    revision: '1bed88bfaaf84e26',
    sideWrap: {
      inverse: [
        115.7155158576, 0.0515483737, -28.5206600751, 0.5302745824, 2.3028368148, -0.5934440575,
        1.5091457013, 0.0013358625, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0693554607795064, 0.0013798311311074775],
    },
  },
  '24-x-20__white-floating-frame': {
    revision: '680ace4aa64f7ea6',
    sideWrap: {
      inverse: [
        105.434312066, 0.0469663477, -25.8977862434, 0.4831362293, 2.2453365075, -0.569867133,
        1.3750320518, 0.0012170928, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06481037771107903, 0.001379831363923725],
    },
  },
  '24-x-24__black-floating-frame': {
    revision: '2dd53c0bab40585c',
    sideWrap: {
      inverse: [
        94.5375508656, -0.0041935935, -18.5508958828, 0.6056421623, 1.6369764495, -0.3199771283,
        1.203691373, -0.0001061093, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06291864412138447, 0.0010895107346785722],
    },
  },
  '24-x-24__espresso-floating-frame': {
    revision: '90300424a27a5be4',
    sideWrap: {
      inverse: [
        94.5378347508, -0.0041873628, -18.5509547135, 0.6056403483, 1.6369796791, -0.3199771602,
        1.2037028293, -0.0001059524, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06291870931763387, 0.0010895106892104805],
    },
  },
  '24-x-24__gallery-wrapped-canvas': {
    revision: '7ad15abb9da1cfd8',
    sideWrap: {
      inverse: [
        69.1956819, 0.0020450264, -11.9949414245, 0.5016702857, 1.4519273779, -0.2249906687,
        1.0204526361, 0.0000598727, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.04827283083806926, 0.0010128840043253475],
    },
  },
  '24-x-24__natural-floating-frame': {
    revision: '48f60a7e9680b76d',
    sideWrap: {
      inverse: [
        106.7434996153, 0.0177149172, -26.2944361292, 0.5411511396, 1.7680764802, -0.3833276007,
        1.0811337616, 0.0003570279, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06952893436616972, 0.0011515460883749502],
    },
  },
  '24-x-24__white-floating-frame': {
    revision: '94779221ffc768af',
    sideWrap: {
      inverse: [
        94.5374327123, -0.0041937611, -18.5508726115, 0.605638795, 1.6369758149, -0.3199763718,
        1.20368898, -0.0001061135, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06291859009079666, 0.0010895107398329756],
    },
  },
  '24-x-30__black-floating-frame': {
    revision: '7ca7c4444459abeb',
    sideWrap: {
      inverse: [
        117.0926611482, 0.0147259161, -29.8172002739, 0.4535909777, 1.6303016327, -0.3074544636,
        0.9657526262, 0.0002419106, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.07766755326007609, 0.0010812986881661231],
    },
  },
  '24-x-30__espresso-floating-frame': {
    revision: '6ad0cf027e5d258e',
    sideWrap: {
      inverse: [
        117.0922233566, 0.0147238208, -29.8170877724, 0.4535853711, 1.6302974897, -0.3074525241,
        0.9657404932, 0.000241874, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0776674622271713, 0.001081298727684356],
    },
  },
  '24-x-30__gallery-wrapped-canvas': {
    revision: '317cabf9013c3093',
    sideWrap: {
      inverse: [
        82.5059283658, 0.0068534393, -17.3296767836, 0.4532607895, 1.4188599698, -0.2266990679,
        0.7524625461, 0.0001244375, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0588280742100035, 0.0010116260020241535],
    },
  },
  '24-x-30__natural-floating-frame': {
    revision: '98d586ee14477789',
    sideWrap: {
      inverse: [
        109.9477558926, -0.0369385829, -33.6530286555, 0.3400724148, 1.6003240727, -0.3292707976,
        0.4896870033, -0.000328309, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.07933264484567028, 0.0011548298007694423],
    },
  },
  '24-x-30__white-floating-frame': {
    revision: 'd78c65959237c653',
    sideWrap: {
      inverse: [
        117.0463104642, 0.0147182062, -29.8050025846, 0.453411169, 1.6301684044, -0.3073914627,
        0.9653659269, 0.0002417828, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.07764315275369084, 0.0010812987086321324],
    },
  },
  '24-x-32__black-floating-frame': {
    revision: '87a3e711fdb62114',
    sideWrap: {
      inverse: [
        121.6294742417, 0.0209514765, -32.6983934351, 0.4598485254, 1.6333349043, -0.3131567154,
        0.9445083649, 0.0003241325, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.08020019439613588, 0.0010768835104946776],
    },
  },
  '24-x-32__espresso-floating-frame': {
    revision: '8457477a698694c8',
    sideWrap: {
      inverse: [
        121.6298013481, 0.0209632008, -32.6984872046, 0.4598474794, 1.6333357847, -0.3131565413,
        0.9445103004, 0.0003243137, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.08020037150169376, 0.0010768835131564475],
    },
  },
  '24-x-32__gallery-wrapped-canvas': {
    revision: '89d779e6c6d52d66',
    sideWrap: {
      inverse: [
        89.4336527979, 0.0190615217, -22.8896510297, 0.4358172386, 1.4770737024, -0.2553985352,
        0.747028015, 0.0003171042, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06203853868995906, 0.0010245098922926493],
    },
  },
  '24-x-32__natural-floating-frame': {
    revision: 'a5b074b505e3a208',
    sideWrap: {
      inverse: [
        127.09838632, -0.0064517742, -40.6153018868, 0.4299946972, 1.7209685441, -0.3754443515,
        0.7635301001, -0.000077284, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.0846314239891617, 0.001145972750769727],
    },
  },
  '24-x-32__white-floating-frame': {
    revision: '6d97dd7b33babd03',
    sideWrap: {
      inverse: [
        110.4360693432, 0.0190227603, -29.5971717752, 0.4175269132, 1.6019474215, -0.2977896559,
        0.8575898506, 0.0002942952, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.07424570066596689, 0.001076883494750779],
    },
  },
  '24-x-36__black-floating-frame': {
    revision: '1a5d2c1f45e69be1',
    sideWrap: {
      inverse: [
        135.4798429402, 0.0527166048, -38.5816391076, 0.2648728726, 1.5533626223, -0.253288896,
        0.6903333046, 0.0005358736, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.09386185748447273, 0.0010760000958634091],
    },
  },
  '24-x-36__espresso-floating-frame': {
    revision: '40043dd37a350fc3',
    sideWrap: {
      inverse: [
        135.4801895938, 0.052721904, -38.581740406, 0.264872037, 1.5533629528, -0.2532886931,
        0.6903340597, 0.0005359267, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.09386207963386564, 0.0010760000998617193],
    },
  },
  '24-x-36__gallery-wrapped-canvas': {
    revision: 'df62e1e8bebd046b',
    sideWrap: {
      inverse: [
        99.6414691614, 0.008266705, -28.0698120473, 0.3795162816, 1.5174966962, -0.2477538289,
        0.8350676599, 0.0001379816, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.06665602813029334, 0.0010150964498595347],
    },
  },
  '24-x-36__natural-floating-frame': {
    revision: '6c4f4fc7f6cb8167',
    sideWrap: {
      inverse: [
        169.8108901439, 0.0063395395, -58.2341515895, 0.6372693203, 1.9610146461, -0.4802709809,
        1.2710070046, 0.0000945457, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.09781337061445333, 0.0011295437421328803],
    },
  },
  '24-x-36__white-floating-frame': {
    revision: 'cf34ac8ce9efc082',
    sideWrap: {
      inverse: [
        143.8875077456, 0.0562449063, -40.8561766916, 0.591051128, 1.8048258577, -0.3774723252,
        1.3524115135, 0.0010523521, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.08580782752651016, 0.0010760002257671373],
    },
  },
  '24-x-48__black-floating-frame': {
    revision: '9bef1b2ce3e5739d',
    sideWrap: {
      inverse: [
        269.8148750422, 0.1137756459, -105.3969679959, 0.4937132543, 2.254882555, -0.4696779507,
        1.7817147902, 0.0014977774, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.13168058657535311, 0.0011001078248532084],
    },
  },
  '24-x-48__espresso-floating-frame': {
    revision: '5ba2d3aad42e53b0',
    sideWrap: {
      inverse: [
        269.8158055359, 0.1137772812, -105.3973320901, 0.493715765, 2.2548891119, -0.4696797398,
        1.7817273224, 0.0014978042, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.13168065688107206, 0.0011001078117744633],
    },
  },
  '24-x-48__gallery-wrapped-canvas': {
    revision: '75b1c52ec4f19bc0',
    sideWrap: {
      inverse: [
        157.9432622264, 0.013247596, -52.1278862506, 0.5104160951, 1.8257803351, -0.338993954,
        1.4573000249, 0.0002433386, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.08805103641371088, 0.0010177776475435941],
    },
  },
  '24-x-48__natural-floating-frame': {
    revision: 'fc5ba7374d074510',
    sideWrap: {
      inverse: [
        270.6270019161, 0.1141123143, -105.717209354, 0.4951871843, 2.2576954327, -0.4706044419,
        1.7870765992, 0.0015022087, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.13191245703117016, 0.0011001078260631128],
    },
  },
  '24-x-48__white-floating-frame': {
    revision: 'c91f8dafff5da37c',
    sideWrap: {
      inverse: [
        220.2873305462, 0.0928878514, -85.8665989187, 0.4030695651, 2.0833153631, -0.4128745158,
        1.4546940393, 0.0012228212, 1,
      ],
      depth: 0.052083333333333336,
      feather: [0.11635832743397921, 0.0011001078048640067],
    },
  },
  '30-x-15__gallery-wrapped-canvas': {
    revision: '121a183874c4de27',
    sideWrap: {
      inverse: [
        61.5973557489, -0.0030211056, -5.3882588827, 0.4109125756, 2.0694930835, -0.5370903539,
        0.7556941193, -0.0000736729, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.04755845589902849, 0.001597855056565208],
    },
  },
  '30-x-20__black-floating-frame': {
    revision: '9f26e879db9ac260',
    sideWrap: {
      inverse: [
        83.9611340676, 0.02940467, -10.2649687525, 0.3842783925, 1.698427393, -0.3516533675,
        0.7389772447, 0.0005153263, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06359761409604814, 0.001286303948751687],
    },
  },
  '30-x-20__espresso-floating-frame': {
    revision: '2ab3f04d28e2d333',
    sideWrap: {
      inverse: [
        83.961172889, 0.0294045486, -10.2649734305, 0.3842771992, 1.6984287936, -0.3516534639,
        0.7389842448, 0.0005153288, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06359758856264873, 0.001286303897512013],
    },
  },
  '30-x-20__gallery-wrapped-canvas': {
    revision: 'c136e074bee7d499',
    sideWrap: {
      inverse: [
        65.3429582914, -0.001470582, -6.0434876664, 0.4442968, 1.5920903564, -0.2975619559,
        0.8719338889, -0.0000389849, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.04971696366192424, 0.0012113756313293755],
    },
  },
  '30-x-20__natural-floating-frame': {
    revision: '95175d0acc590122',
    sideWrap: {
      inverse: [
        109.206195418, 0.017087705, -25.354075071, 0.2436936813, 2.2076008431, -0.6051115973,
        0.4681896148, 0.0001462029, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.08172825274826023, 0.0016520801110371827],
    },
  },
  '30-x-20__white-floating-frame': {
    revision: '3d16a3be43e2ffb9',
    sideWrap: {
      inverse: [
        83.9613093009, 0.0294034453, -10.2649895327, 0.3842805543, 1.6984282929, -0.3516538002,
        0.7389819393, 0.0005153071, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06359771156797124, 0.0012863039245030229],
    },
  },
  '30-x-24__black-floating-frame': {
    revision: '1f893a9b8d6a3a97',
    sideWrap: {
      inverse: [
        90.7517641167, -0.0289689625, -11.0647934784, 0.4943206819, 1.4981930289, -0.2351265383,
        1.2199670533, -0.0007736001, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06495839364273069, 0.0010726553200422245],
    },
  },
  '30-x-24__espresso-floating-frame': {
    revision: '126bd67feb3f3ed7',
    sideWrap: {
      inverse: [
        90.751900993, -0.028969286, -11.0648100274, 0.4943219414, 1.4981943679, -0.235126851,
        1.219975209, -0.0007736128, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06495843102513862, 0.001072655282477072],
    },
  },
  '30-x-24__gallery-wrapped-canvas': {
    revision: '23d8ff885f970007',
    sideWrap: {
      inverse: [
        67.6891883921, 0.0050229391, -6.7150211774, 0.4418491092, 1.3965016854, -0.1865819631,
        1.1105446506, 0.0001634669, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.04997477701241088, 0.0010309736335177698],
    },
  },
  '30-x-24__natural-floating-frame': {
    revision: '2723fe26cc60d120',
    sideWrap: {
      inverse: [
        129.7126371341, 0.0065326707, -30.1080875116, 0.4363248566, 2.1723627816, -0.5334349314,
        1.309462521, 0.0001312309, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.08205911188176818, 0.0013742436413233853],
    },
  },
  '30-x-24__white-floating-frame': {
    revision: 'f31eae798af72d2d',
    sideWrap: {
      inverse: [
        90.7518912648, -0.0289641933, -11.0648113866, 0.4943211257, 1.4981943088, -0.2351267502,
        1.2199739487, -0.0007734761, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.06495842999176762, 0.0010726552891548971],
    },
  },
  '30-x-30__black-floating-frame': {
    revision: '44f9cdc088048a05',
    sideWrap: {
      inverse: [
        120.2714829906, 0.0035533785, -27.9147819019, 0.4892711149, 1.6326186913, -0.316744879,
        0.9689695127, 0.0000570251, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.08116411770262422, 0.0011017386511733504],
    },
  },
  '30-x-30__espresso-floating-frame': {
    revision: 'a34aedfd2b0429fa',
    sideWrap: {
      inverse: [
        120.2715531491, 0.0035548872, -27.9147989382, 0.4892703186, 1.6326198822, -0.3167448391,
        0.9689732013, 0.0000570495, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.08116410539332655, 0.0011017386368093827],
    },
  },
  '30-x-30__gallery-wrapped-canvas': {
    revision: 'c8070c276fd6a2d6',
    sideWrap: {
      inverse: [
        82.1007254763, 0.0062577073, -14.4391760573, 0.4060255727, 1.4006987536, -0.2043896766,
        0.7737835126, 0.0001173994, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.059652711669260484, 0.0010176764859461023],
    },
  },
  '30-x-30__natural-floating-frame': {
    revision: 'b3e776ad034fc6e1',
    sideWrap: {
      inverse: [
        120.2830344322, 0.0035543217, -27.9175566069, 0.4893201367, 1.6326507652, -0.3167606395,
        0.9690697443, 0.0000570406, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.08117031637392116, 0.0011017386182163235],
    },
  },
  '30-x-30__white-floating-frame': {
    revision: 'dc9cc23d6c60bcb1',
    sideWrap: {
      inverse: [
        109.3151314225, 0.0032336569, -25.2807396368, 0.4446875012, 1.6043292034, -0.3025058656,
        0.8806960957, 0.0000518939, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.07507103585601495, 0.0011017386681148756],
    },
  },
  '30-x-40__black-floating-frame': {
    revision: '1c9c422d33125c27',
    sideWrap: {
      inverse: [
        154.6634071627, 0.0196082127, -39.9000739289, 0.5334433805, 1.6315980233, -0.3213201919,
        1.0240595193, 0.0002588003, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.10127145310024327, 0.0010682630182445659],
    },
  },
  '30-x-40__espresso-floating-frame': {
    revision: '3788e2a477167633',
    sideWrap: {
      inverse: [
        154.6636275109, 0.0196088656, -39.9001310872, 0.533451942, 1.6315994564, -0.3213225948,
        1.0240637459, 0.0002588096, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.10127150780690237, 0.0010682630086583764],
    },
  },
  '30-x-40__gallery-wrapped-canvas': {
    revision: '98581b78fce48305',
    sideWrap: {
      inverse: [
        103.5306790179, 0.0100661163, -26.664182943, 0.2992437987, 1.410391327, -0.2097799185,
        0.5633421931, 0.0001092475, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.07493220552865489, 0.0010207567538032],
    },
  },
  '30-x-40__natural-floating-frame': {
    revision: 'd16fbad6dcfa8840',
    sideWrap: {
      inverse: [
        159.0468097738, 0.0164813308, -49.7766317196, 0.2034471778, 1.4785543046, -0.2473526106,
        0.3517985065, 0.0000728299, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.11912729033071588, 0.0011074213302720457],
    },
  },
  '30-x-40__white-floating-frame': {
    revision: 'b402748e466cd475',
    sideWrap: {
      inverse: [
        154.6636862816, 0.0196016939, -39.9001426596, 0.5334508695, 1.6316000261, -0.3213223675,
        1.0240657596, 0.0002587154, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.10127150746733957, 0.0010682630030301088],
    },
  },
  '30-x-60__black-floating-frame': {
    revision: '626e1bc26c19ce5b',
    sideWrap: {
      inverse: [
        360.39514805, 0.0626512919, -139.2338843139, 0.7535842318, 2.5287794277, -0.5787149211,
        2.45493056, 0.0008506534, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.15307750861529057, 0.0010739158160527503],
    },
  },
  '30-x-60__espresso-floating-frame': {
    revision: '053faaddc897e5d8',
    sideWrap: {
      inverse: [
        360.3918781595, 0.0626436659, -139.2326175154, 0.7535712386, 2.528763926, -0.5787081162,
        2.4548999128, 0.0008505469, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.15307705683373996, 0.0010739158286020554],
    },
  },
  '30-x-60__gallery-wrapped-canvas': {
    revision: '3639ce454a59faa2',
    sideWrap: {
      inverse: [
        206.4335833657, 0.0268680371, -68.4805413624, 0.4978285037, 1.8935010918, -0.3413671896,
        1.6184416901, 0.0004196489, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.1110499290197888, 0.0010184865228541674],
    },
  },
  '30-x-60__natural-floating-frame': {
    revision: '28e09726580d74b6',
    sideWrap: {
      inverse: [
        360.3989730635, 0.0626331496, -139.2353526747, 0.7536006389, 2.5288012363, -0.5787237476,
        2.4549744516, 0.0008504132, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.15307780182475864, 0.0010739157894658468],
    },
  },
  '30-x-60__white-floating-frame': {
    revision: '53a883b19c23f687',
    sideWrap: {
      inverse: [
        360.3948573987, 0.0626331425, -139.2337629958, 0.7535836895, 2.5287755175, -0.5787142526,
        2.4549233152, 0.0008504051, 1,
      ],
      depth: 0.041666666666666664,
      feather: [0.15307761550930765, 0.0010739158240034266],
    },
  },
  '32-x-16__black-floating-frame': {
    revision: 'd8da97781a2614bb',
    sideWrap: {
      inverse: [
        99.5718563999, 0.0027003163, -22.6954347786, 0.1022354672, 2.7102786756, -0.8606316772,
        0.1476405592, 0.0000080019, 1,
      ],
      depth: 0.0390625,
      feather: [0.08015594226586467, 0.0021817873866826053],
    },
  },
  '32-x-16__espresso-floating-frame': {
    revision: '2b384a9ee5e944cc',
    sideWrap: {
      inverse: [
        99.5718686298, 0.0026847221, -22.6954297747, 0.1022475414, 2.7102834791, -0.8606359728,
        0.1476485606, 0.0000079561, 1,
      ],
      depth: 0.0390625,
      feather: [0.08015580615699724, 0.002181787299158787],
    },
  },
  '32-x-16__natural-floating-frame': {
    revision: 'b70ce7f3af48882d',
    sideWrap: {
      inverse: [
        164.2133185803, 0.004516261, -37.5660493465, 0.8851845199, 4.1115600188, -1.4795935404,
        2.3931659497, 0.0001306767, 1,
      ],
      depth: 0.0390625,
      feather: [0.0871407037497585, 0.0021817872750002393],
    },
  },
  '32-x-16__white-floating-frame': {
    revision: 'f755629c8e60bad7',
    sideWrap: {
      inverse: [
        144.4469814199, 0.0039440539, -32.9238418185, 0.7786608134, 3.9318055973, -1.3987429016,
        2.1051159344, 0.0001141208, 1,
      ],
      depth: 0.0390625,
      feather: [0.08015583299821477, 0.0021817871660072883],
    },
  },
  '32-x-24__black-floating-frame': {
    revision: '196106278614098c',
    sideWrap: {
      inverse: [
        93.1111216896, 0.0020284835, -11.1355522257, 0.3597074001, 1.5423518528, -0.254064557,
        1.0017465589, 0.0000434126, 1,
      ],
      depth: 0.0390625,
      feather: [0.06854528643962453, 0.0011354117258681469],
    },
  },
  '32-x-24__espresso-floating-frame': {
    revision: '71f454eb248e4fad',
    sideWrap: {
      inverse: [
        93.1110443726, 0.002031734, -11.1355446047, 0.3597050612, 1.542349926, -0.2540640056,
        1.0017349418, 0.0000434817, 1,
      ],
      depth: 0.0390625,
      feather: [0.06854532068289425, 0.0011354117919439854],
    },
  },
  '32-x-24__gallery-wrapped-canvas': {
    revision: '2e2fe0a0b92be47f',
    sideWrap: {
      inverse: [
        71.5346717938, 0.0014714021, -6.6176925796, 0.4597927553, 1.4436372409, -0.211559974,
        1.1357138287, 0.0000463504, 1,
      ],
      depth: 0.0390625,
      feather: [0.05308761591574323, 0.0010713410047389787],
    },
  },
  '32-x-24__natural-floating-frame': {
    revision: 'f1672dc3cffc2b59',
    sideWrap: {
      inverse: [
        144.1406369324, 0.0506115119, -32.9974234858, 0.4807199127, 2.3553054884, -0.6157155596,
        1.4808236929, 0.0010346088, 1,
      ],
      depth: 0.0390625,
      feather: [0.08877156590457772, 0.0014502373380273533],
    },
  },
  '32-x-24__white-floating-frame': {
    revision: '2b14bcc1ac30a78f',
    sideWrap: {
      inverse: [
        95.7796304089, 0.0020978687, -11.4546978233, 0.5875117164, 1.586560969, -0.2900015165,
        1.247957961, 0.0000543121, 1,
      ],
      depth: 0.0390625,
      feather: [0.06854522421906492, 0.001135411722928052],
    },
  },
  '32-x-32__black-floating-frame': {
    revision: '8d59f3b96f85182f',
    sideWrap: {
      inverse: [
        127.7250948655, 0.0450706531, -24.0242290525, 0.577131039, 1.5629316179, -0.2916484932,
        1.0526479479, 0.000739831, 1,
      ],
      depth: 0.0390625,
      feather: [0.08809956819736, 0.0010777914247843473],
    },
  },
  '32-x-32__espresso-floating-frame': {
    revision: '7dbcbfe6d6f7545a',
    sideWrap: {
      inverse: [
        127.7265098949, 0.0450638258, -24.0244915417, 0.5771369396, 1.5629439101, -0.2916510285,
        1.0526975888, 0.0007397455, 1,
      ],
      depth: 0.0390625,
      feather: [0.08809983561046357, 0.0010777912638532106],
    },
  },
  '32-x-32__gallery-wrapped-canvas': {
    revision: 'c047db337cf5dca8',
    sideWrap: {
      inverse: [
        88.0664512879, 0.0112452006, -15.6374232359, 0.4937400403, 1.4486019638, -0.2303916818,
        0.9269984948, 0.0002354902, 1,
      ],
      depth: 0.0390625,
      feather: [0.06234953809509878, 0.0010255020177253073],
    },
  },
  '32-x-32__natural-floating-frame': {
    revision: 'e40916c8c95f0949',
    sideWrap: {
      inverse: [
        129.2814512445, -0.0078268467, -29.5692284868, 0.3147498484, 1.5940353808, -0.261440057,
        0.9232248812, -0.0001113864, 1,
      ],
      depth: 0.0390625,
      feather: [0.08831785801486065, 0.0010889939202642154],
    },
  },
  '32-x-32__white-floating-frame': {
    revision: 'd2d581ef26077ea0',
    sideWrap: {
      inverse: [
        115.4393151045, 0.0407373253, -21.6171582867, 0.5216089957, 1.5370102816, -0.2777357816,
        0.9514328163, 0.0006687272, 1,
      ],
      depth: 0.0390625,
      feather: [0.08096663750024714, 0.0010777912371215176],
    },
  },
  '32-x-48__black-floating-frame': {
    revision: '1f611dc0eb46466d',
    sideWrap: {
      inverse: [
        165.4612495274, 0.0051603865, -46.1249031472, 0.2446502987, 1.4437633208, -0.2236422301,
        0.4767491121, 0.0000296947, 1,
      ],
      depth: 0.0390625,
      feather: [0.12135759021495297, 0.0010589176383271409],
    },
  },
  '32-x-48__espresso-floating-frame': {
    revision: '9ace39f26cff0536',
    sideWrap: {
      inverse: [
        183.8646048883, 0.0057509756, -51.2551289167, 0.2718555994, 1.6043560467, -0.2485162527,
        0.9191644578, 0.0000573563, 1,
      ],
      depth: 0.0390625,
      feather: [0.1213576980227123, 0.001058917635367603],
    },
  },
  '32-x-48__gallery-wrapped-canvas': {
    revision: 'c9d038ddda9638c4',
    sideWrap: {
      inverse: [
        144.3846481521, 0.0126920299, -40.7950080751, 0.5554026337, 1.6172478666, -0.3070475975,
        1.1213047299, 0.0001963696, 1,
      ],
      depth: 0.0390625,
      feather: [0.09065925045812613, 0.001015409731981293],
    },
  },
  '32-x-48__natural-floating-frame': {
    revision: 'a1ee9b78a7b8fa40',
    sideWrap: {
      inverse: [
        241.9140886781, 0.0129115024, -81.1484780021, 0.9006611401, 1.8725358996, -0.5255889164,
        1.2731155138, 0.0001355395, 1,
      ],
      depth: 0.0390625,
      feather: [0.14051837211725005, 0.0010876430751443902],
    },
  },
  '32-x-48__white-floating-frame': {
    revision: 'f634bb31daee5138',
    sideWrap: {
      inverse: [
        176.456987756, 0.0055309125, -49.0431029283, 0.6346307735, 1.726583282, -0.3651527062,
        1.2558577863, 0.0000784477, 1,
      ],
      depth: 0.0390625,
      feather: [0.1082239455303072, 0.0010589176008438742],
    },
  },
  '36-x-12__black-floating-frame': {
    revision: '77c0b9d8617810d9',
    sideWrap: {
      inverse: [
        158.2602864313, 0.0609775164, -35.1774339449, 0.737327479, 5.1759758631, -2.0841815461,
        1.4863914508, 0.0011400316, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.09817967238271234, 0.0032106577069671294],
    },
  },
  '36-x-12__espresso-floating-frame': {
    revision: '8cd368c8fb551b4d',
    sideWrap: {
      inverse: [
        158.2603301563, 0.0609911731, -35.1774504771, 0.737318754, 5.1759780791, -2.0841804004,
        1.486393269, 0.001140288, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.09817965946307586, 0.003210657692492673],
    },
  },
  '36-x-12__gallery-wrapped-canvas': {
    revision: 'fe3a63901433db7d',
    sideWrap: {
      inverse: [
        77.5207785674, 0.019725379, -7.3097304365, 0.2719238999, 3.1513874237, -1.0635390939,
        0.7818532791, 0.0003958868, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.05955334483553529, 0.002420819975250237],
    },
  },
  '36-x-12__natural-floating-frame': {
    revision: '61d8440229586217',
    sideWrap: {
      inverse: [
        249.8946162747, 0.0969277301, -55.7541769927, 2.7693445956, 7.3712051449, -3.3646291314,
        3.9520110256, 0.0030414019, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.10886838101889876, 0.003210657676801216],
    },
  },
  '36-x-12__white-floating-frame': {
    revision: '5f99361058c3d6a8',
    sideWrap: {
      inverse: [
        139.8196113581, 0.0538743955, -30.9620025702, 0.6514121347, 5.0217816499, -2.0073447822,
        1.3131780413, 0.0010072189, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.08940213505941046, 0.003210657908020732],
    },
  },
  '36-x-24__black-floating-frame': {
    revision: 'd2e803ed9712212d',
    sideWrap: {
      inverse: [
        108.8892948762, 0.080638169, -12.8801413419, 0.3122602285, 1.6882290819, -0.3304079976,
        0.8406898823, 0.0012404004, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.0818773931053584, 0.001268966969590235],
    },
  },
  '36-x-24__espresso-floating-frame': {
    revision: '9e5828ddfe527d94',
    sideWrap: {
      inverse: [
        108.8893917523, 0.0806416904, -12.8801545237, 0.3122595222, 1.6882292715, -0.3304079453,
        0.8406905765, 0.0012404545, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.08187745808636258, 0.001268966969850645],
    },
  },
  '36-x-24__gallery-wrapped-canvas': {
    revision: '4875f6959a823053',
    sideWrap: {
      inverse: [
        78.6199195257, 0.0023205156, -7.3390207653, 0.5200025069, 1.5928566478, -0.3010708058,
        0.9603283, 0.0000563431, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.059391321494406735, 0.0012032598034236255],
    },
  },
  '36-x-24__natural-floating-frame': {
    revision: 'c56eac8442bf21a5',
    sideWrap: {
      inverse: [
        159.2152121009, -0.0138818784, -35.48478851, 0.4892382182, 2.3386025324, -0.6731553058,
        0.936336941, -0.0001627973, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.10912989316165438, 0.0016029895754160045],
    },
  },
  '36-x-24__white-floating-frame': {
    revision: 'db0276a47e0d2a15',
    sideWrap: {
      inverse: [
        103.2073580629, 0.0766340134, -12.1222039853, 0.5580396145, 1.7312930586, -0.3693562181,
        1.0588555047, 0.0015643676, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.07568098129068533, 0.001268966973655567],
    },
  },
  '36-x-36__black-floating-frame': {
    revision: '62868a3c68b1ad18',
    sideWrap: {
      inverse: [
        134.0779269311, 0.0132596806, -29.783096875, 0.3059160394, 1.4653494131, -0.2310536934,
        0.6203849931, 0.0001224225, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.09774204989546202, 0.0010681867985805466],
    },
  },
  '36-x-36__espresso-floating-frame': {
    revision: '6887e34ab7c94484',
    sideWrap: {
      inverse: [
        143.5628785536, 0.0142300349, -31.8900194346, 0.3275565762, 1.5690402241, -0.2474019726,
        0.9709485916, 0.000191833, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.09774214864650344, 0.0010681868314643464],
    },
  },
  '36-x-36__gallery-wrapped-canvas': {
    revision: '29e357c2c83c3b7c',
    sideWrap: {
      inverse: [
        102.2786814056, 0.0120424905, -17.3081616326, 0.4327673337, 1.4334764309, -0.2077155237,
        0.9677910184, 0.0002268219, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.07254151930722706, 0.00101661777991247],
    },
  },
  '36-x-36__natural-floating-frame': {
    revision: '3f5818bc4b90a611',
    sideWrap: {
      inverse: [
        150.9416377383, 0.0149095457, -33.6548548795, 0.3443879219, 1.4884262185, -0.2424546852,
        0.6983935533, 0.0001376511, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.10833008104599598, 0.0010681868716365644],
    },
  },
  '36-x-36__white-floating-frame': {
    revision: 'be8e159cb4a103a9',
    sideWrap: {
      inverse: [
        136.8733059261, 0.0135771141, -30.2900014485, 0.6047267042, 1.6421722389, -0.3193405192,
        1.2181101619, 0.000240585, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.08903876545582316, 0.0010681869316637041],
    },
  },
  '36-x-48__gallery-wrapped-canvas': {
    revision: '0058407caff61b4e',
    sideWrap: {
      inverse: [
        131.9034416377, 0.0052380359, -33.0883976372, 0.4683839165, 1.4850231385, -0.2576282833,
        0.8133808665, 0.0000644013, 1,
      ],
      depth: 0.034722222222222224,
      feather: [0.09072801353023627, 0.001021431112501898],
    },
  },
  '40-x-20__gallery-wrapped-canvas': {
    revision: '4cef8d79eeb00727',
    sideWrap: {
      inverse: [
        88.8426991766, -0.0014026111, -7.9211064873, 0.5664609843, 2.1125192034, -0.5584056598,
        1.0697040268, -0.0000335727, 1,
      ],
      depth: 0.03125,
      feather: [0.0667760687601476, 0.0015878271303659212],
    },
  },
  '40-x-30__black-floating-frame': {
    revision: 'ecade18cec74bfbb',
    sideWrap: {
      inverse: [
        127.4822057699, -0.0144346196, -14.8125863339, 0.4456779756, 1.522233568, -0.2497655312,
        1.0913429127, -0.0002460826, 1,
      ],
      depth: 0.03125,
      feather: [0.09347713361030881, 0.0011162776718907344],
    },
  },
  '40-x-30__espresso-floating-frame': {
    revision: 'c1f038b4eb4ded88',
    sideWrap: {
      inverse: [
        127.4819109798, -0.0144378639, -14.8125504418, 0.4456722317, 1.5222322619, -0.2497646686,
        1.0913351854, -0.0002461367, 1,
      ],
      depth: 0.03125,
      feather: [0.09347699790285478, 0.0011162776947850677],
    },
  },
  '40-x-30__gallery-wrapped-canvas': {
    revision: '7dfe9c687acb61c9',
    sideWrap: {
      inverse: [
        88.7105085663, 0.0024001052, -8.1329986086, 0.384617306, 1.3898984793, -0.1957043817,
        0.7771842406, 0.00004187, 1,
      ],
      depth: 0.03125,
      feather: [0.06840317049591467, 0.0010717110301604717],
    },
  },
  '40-x-30__natural-floating-frame': {
    revision: '4aee671128c3dbb5',
    sideWrap: {
      inverse: [
        145.1094037122, 0.054049073, -31.5278011201, 0.0429771238, 1.9084312328, -0.3967548677,
        0.597479787, 0.0004441937, 1,
      ],
      depth: 0.03125,
      feather: [0.10658463028275655, 0.001401602534838971],
    },
  },
  '40-x-30__white-floating-frame': {
    revision: '0efd355c029ee7ec',
    sideWrap: {
      inverse: [
        119.071876837, -0.0135174502, -13.7361290592, 0.4162653015, 1.5546990759, -0.2502229257,
        1.285202195, -0.0002902217, 1,
      ],
      depth: 0.03125,
      feather: [0.08548590161395427, 0.00111627768866014],
    },
  },
  '40-x-60__black-floating-frame': {
    revision: '825dbeaee8147a8a',
    sideWrap: {
      inverse: [
        232.2154639385, -0.0030855126, -76.5328050737, 0.4961654235, 1.674172622, -0.3456002941,
        0.9369604487, -0.0000248491, 1,
      ],
      depth: 0.03125,
      feather: [0.14725931574259846, 0.001061683575915123],
    },
  },
  '40-x-60__espresso-floating-frame': {
    revision: '94973e9b8be1ca5f',
    sideWrap: {
      inverse: [
        232.2177420405, -0.003086652, -76.5335553289, 0.4961774628, 1.6741840888, -0.3456055285,
        0.9369875197, -0.0000248587, 1,
      ],
      depth: 0.03125,
      feather: [0.14725974568659017, 0.001061683534961014],
    },
  },
  '40-x-60__gallery-wrapped-canvas': {
    revision: '6e00432135059ba2',
    sideWrap: {
      inverse: [
        188.9479224124, 0.0108625822, -51.65119141, 0.5144844437, 1.5823133866, -0.2867880369,
        1.0554665409, 0.0001210183, 1,
      ],
      depth: 0.03125,
      feather: [0.12151376180169855, 0.0010175581495659957],
    },
  },
  '40-x-60__natural-floating-frame': {
    revision: '5c89862f8b31d446',
    sideWrap: {
      inverse: [
        362.1619456996, -0.0048331514, -119.6619241264, 1.5428186416, 2.2265152244, -0.7556210142,
        2.230287784, -0.0000593445, 1,
      ],
      depth: 0.03125,
      feather: [0.1726897072738739, 0.001061683550293939],
    },
  },
  '40-x-60__white-floating-frame': {
    revision: '9e3da0aa4ceeb232',
    sideWrap: {
      inverse: [
        278.1998141689, -0.0037064908, -91.6881671619, 1.1851443391, 2.0056935098, -0.6120701723,
        1.7132286349, -0.0000455107, 1,
      ],
      depth: 0.03125,
      feather: [0.14725919881942867, 0.0010616835497719633],
    },
  },
  '48-x-16__black-floating-frame': {
    revision: '34a915e1d55aa60e',
    sideWrap: {
      inverse: [
        139.0504142276, 0.0557217991, -15.3813387913, 0.5493056369, 3.4253475393, -1.2061577747,
        1.2074926568, 0.0009635634, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.10131320704126315, 0.002495383314729581],
    },
  },
  '48-x-16__espresso-floating-frame': {
    revision: 'deee54841cf2292e',
    sideWrap: {
      inverse: [
        139.0502465382, 0.055665812, -15.3812922908, 0.5493454601, 3.4253491409, -1.2061628404,
        1.2075027014, 0.0009626044, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.10131301908840457, 0.0024953832117038614],
    },
  },
  '48-x-16__gallery-wrapped-canvas': {
    revision: '0a4c23a5e0d604c4',
    sideWrap: {
      inverse: [
        106.3246261425, 0.0349057772, -9.6752993294, 0.4888951857, 3.0769861764, -1.06098164,
        0.5328826193, 0.0003489997, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.08407355637150071, 0.002432912542184312],
    },
  },
  '48-x-16__natural-floating-frame': {
    revision: '44a877013cf91891',
    sideWrap: {
      inverse: [
        239.2308017056, 0.0302484005, -50.1539000737, 0.6964468159, 4.8233476421, -1.9063888699,
        1.4227882318, 0.0003587256, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.15263224688916335, 0.0030772417193103037],
    },
  },
  '48-x-16__white-floating-frame': {
    revision: '8f4fc7b7064cfe7e',
    sideWrap: {
      inverse: [
        139.0502359739, 0.0556937906, -15.3813051093, 0.5493199288, 3.4253439766, -1.2061582058,
        1.2074850938, 0.0009630743, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.10131317751937802, 0.0024953833692508815],
    },
  },
  '48-x-24__black-floating-frame': {
    revision: 'c913b8a402a93be6',
    sideWrap: {
      inverse: [
        194.5621973794, 0.0419828155, -40.6358329853, 0.535045812, 3.010298528, -1.0077043467,
        1.0328750858, 0.0004445658, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.13264484994347725, 0.0020521514958850716],
    },
  },
  '48-x-24__espresso-floating-frame': {
    revision: '96fd146715e622b0',
    sideWrap: {
      inverse: [
        194.5631886689, 0.0419730403, -40.6360350341, 0.5350688962, 3.0103119668, -1.007713225,
        1.032901092, 0.0004444712, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.13264492438296982, 0.002052151386224349],
    },
  },
  '48-x-24__gallery-wrapped-canvas': {
    revision: 'd502e94d397d9b3f',
    sideWrap: {
      inverse: [
        98.2721353325, -0.0055408768, -8.6779365111, 0.4105368247, 2.0433879784, -0.5246562795,
        0.7403126049, -0.0000831677, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.07629079758082491, 0.0015863588288959477],
    },
  },
  '48-x-24__natural-floating-frame': {
    revision: '9c6e49acd4bdc3a2',
    sideWrap: {
      inverse: [
        232.2096687603, 0.0500962711, -48.6923041138, 0.6385927168, 3.116262097, -1.0613956266,
        1.2326992718, 0.0005304657, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.15293002070069647, 0.002052151655319584],
    },
  },
  '48-x-24__white-floating-frame': {
    revision: 'a71d3c81ff38b6b4',
    sideWrap: {
      inverse: [
        193.7565657297, 0.041832653, -40.4634426666, 0.53281623, 3.0080230953, -1.0065501459,
        1.0285831224, 0.0004429692, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.13219550376600628, 0.002052151575938263],
    },
  },
  '48-x-32__black-floating-frame': {
    revision: '3f16a15fc5756397',
    sideWrap: {
      inverse: [
        129.0410740256, 0.0114241566, -14.2539964453, 0.3498364854, 1.6238499206, -0.310076529,
        0.7311727846, 0.0001290965, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.09893152011544373, 0.0012449024847984826],
    },
  },
  '48-x-32__espresso-floating-frame': {
    revision: '3f6fb9cba77461c3',
    sideWrap: {
      inverse: [
        129.041411764, 0.011425561, -14.2540344393, 0.349842252, 1.623852053, -0.3100775441,
        0.7311851086, 0.0001291142, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.09893164566479598, 0.0012449024344382484],
    },
  },
  '48-x-32__gallery-wrapped-canvas': {
    revision: '86f15e8c19f33c35',
    sideWrap: {
      inverse: [
        99.989287892, 0.0047365537, -9.1680565617, 0.4864691489, 1.5577859551, -0.2893316211,
        0.7707167984, 0.000072737, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.07722332388492778, 0.0012030749101203798],
    },
  },
  '48-x-32__natural-floating-frame': {
    revision: '995fbe2579b34765',
    sideWrap: {
      inverse: [
        253.9095823672, -0.0089241682, -53.2107576046, 0.9363226004, 2.5365100763, -0.7811034457,
        1.742007196, -0.0001220328, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.1539446834954539, 0.0015379160865369047],
    },
  },
  '48-x-32__white-floating-frame': {
    revision: 'c0391bb83f4d9dc8',
    sideWrap: {
      inverse: [
        129.0413021443, 0.0114249288, -14.2540220193, 0.3498386908, 1.6238510666, -0.3100769716,
        0.7311794169, 0.0001291062, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.09893162342567856, 0.001244902458966845],
    },
  },
  '48-x-36__gallery-wrapped-canvas': {
    revision: 'c4a68a31f8df4cb7',
    sideWrap: {
      inverse: [
        103.9041853531, 0.0172203565, -9.3599679378, 0.4946966261, 1.4374809436, -0.2023799874,
        1.3164835626, 0.0004336132, 1,
      ],
      depth: 0.026041666666666668,
      feather: [0.07642026874322382, 0.0010570900705633658],
    },
  },
  '6-x-6__black-floating-frame': {
    revision: 'ec065d3275750c91',
    sideWrap: {
      inverse: [
        84.2207493337, 0.0006063379, -35.9695812828, 0.8139898112, 5.9613798705, -2.4797224849,
        1.6210143127, 0.000023116, 1,
      ],
      depth: 0.20833333333333334,
      feather: [0.04067382210365146, 0.002879001150763488],
    },
  },
  '6-x-6__espresso-floating-frame': {
    revision: '7e6a32af0e9c32fc',
    sideWrap: {
      inverse: [
        84.2211699303, 0.0006061144, -35.969760801, 0.8139997849, 5.9614054359, -2.4797359486,
        1.6210311079, 0.0000231076, 1,
      ],
      depth: 0.20833333333333334,
      feather: [0.04067384864766298, 0.002879001000621496],
    },
  },
  '6-x-6__gallery-wrapped-canvas': {
    revision: '78377e5e9e77f772',
    sideWrap: {
      inverse: [
        17.8012703372, 0.0002256, -1.9285902331, 0.5323822265, 1.4665309391, -0.2338029687,
        1.1087337247, 0.0000272274, 1,
      ],
      depth: 0.20833333333333334,
      feather: [0.012418637661425393, 0.00102308131531494],
    },
  },
  '6-x-6__natural-floating-frame': {
    revision: '84cfb3e6af912ee3',
    sideWrap: {
      inverse: [
        90.5781601845, 0.0006674865, -38.7602378498, 0.8754226522, 6.1505928144, -2.5743606949,
        1.7433783699, 0.0000254473, 1,
      ],
      depth: 0.20833333333333334,
      feather: [0.04239837887657039, 0.0028790011243660023],
    },
  },
  '6-x-6__white-floating-frame': {
    revision: 'f473e1daccc0e7d8',
    sideWrap: {
      inverse: [
        78.6980545616, 0.0005789783, -33.5453350098, 0.7606096604, 5.7970287484, -2.3975108197,
        1.5147274739, 0.0000220731, 1,
      ],
      depth: 0.20833333333333334,
      feather: [0.039084195860028044, 0.002879000973113199],
    },
  },
  '60-x-20__black-floating-frame': {
    revision: 'db1840fd0b3ee22b',
    sideWrap: {
      inverse: [
        203.0511940507, -0.0290950665, -40.5110976053, 0.5660095286, 4.3914659494, -1.7010698312,
        1.0621188224, -0.0003035848, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.13890107057995155, 0.00300417044364379],
    },
  },
  '60-x-20__espresso-floating-frame': {
    revision: '6e41ccb7eb77b466',
    sideWrap: {
      inverse: [
        203.0515595534, -0.029104878, -40.5111656513, 0.5660254488, 4.3914799643, -1.7010781177,
        1.0621382815, -0.0003036922, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.13890086961961678, 0.003004170313467422],
    },
  },
  '60-x-20__gallery-wrapped-canvas': {
    revision: '4e7170f6893a1499',
    sideWrap: {
      inverse: [
        142.3735793042, 0.0435771413, -13.1913447409, 0.6647172409, 3.2531759156, -1.1282189704,
        1.2908381018, 0.0007866057, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.10499122821673929, 0.002398714921062673],
    },
  },
  '60-x-20__natural-floating-frame': {
    revision: '0ad903153b346acc',
    sideWrap: {
      inverse: [
        203.0531891855, -0.0290970603, -40.511494805, 0.5660281702, 4.3915046948, -1.701087602,
        1.0621718535, -0.0003036178, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.13890119479459073, 0.003004170127720341],
    },
  },
  '60-x-20__white-floating-frame': {
    revision: '888bd8b2b4d661a3',
    sideWrap: {
      inverse: [
        203.0501194321, -0.0291014419, -40.510879944, 0.5659948159, 4.3914497685, -1.7010610058,
        1.0620968952, -0.0003036467, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.13890085185880394, 0.0030041705645710783],
    },
  },
  '60-x-30__black-floating-frame': {
    revision: 'f5f094e654367319',
    sideWrap: {
      inverse: [
        206.7115460727, 0.0344828284, -41.2734065715, 0.5596200704, 2.9241661805, -0.967457123,
        1.0530940087, 0.0003504506, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.14159623255520365, 0.00200291715038955],
    },
  },
  '60-x-30__espresso-floating-frame': {
    revision: 'd661e7bfd602f8f4',
    sideWrap: {
      inverse: [
        206.7118123252, 0.0344739563, -41.2734552791, 0.5596245558, 2.9241664616, -0.9674581068,
        1.0530949196, 0.0003503603, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.1415963992887889, 0.0020029171525649788],
    },
  },
  '60-x-30__gallery-wrapped-canvas': {
    revision: '93bc814db462896b',
    sideWrap: {
      inverse: [
        137.6519590478, -0.0208021148, -12.3782803746, 0.5009307386, 2.0561004008, -0.5345014062,
        0.8479794685, -0.0002555072, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.10593288176303967, 0.0015824123753700092],
    },
  },
  '60-x-30__natural-floating-frame': {
    revision: '692c7e228d046fbe',
    sideWrap: {
      inverse: [
        206.7110759361, 0.0344714858, -41.2733070744, 0.5596233058, 2.9241563415, -0.9674548964,
        1.0530742861, 0.0003503296, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.14159638999527738, 0.0020029172345698847],
    },
  },
  '60-x-30__white-floating-frame': {
    revision: '852b85f623de3fe6',
    sideWrap: {
      inverse: [
        206.7116951681, 0.0344774111, -41.2734336228, 0.5596240593, 2.9241614287, -0.9674565362,
        1.0530845107, 0.0003503921, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.14159656690165476, 0.0020029172002221144],
    },
  },
  '60-x-40__black-floating-frame': {
    revision: 'b89c73d4fbd88634',
    sideWrap: {
      inverse: [
        213.6369764901, -0.0232767828, -42.626748614, 0.7100503949, 2.2858340306, -0.6533518851,
        1.3085582527, -0.000284275, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.14031514390159155, 0.0015014117524213637],
    },
  },
  '60-x-40__espresso-floating-frame': {
    revision: '739b862e445852f1',
    sideWrap: {
      inverse: [
        213.6353360112, -0.023281114, -42.626419037, 0.710038525, 2.2858187325, -0.6533460688,
        1.3085166262, -0.000284321, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.1403150144423672, 0.0015014118637155444],
    },
  },
  '60-x-40__gallery-wrapped-canvas': {
    revision: 'd6c510cd7b169005',
    sideWrap: {
      inverse: [
        133.805344464, -0.0098841093, -12.1490465086, 0.5588743583, 1.5750664255, -0.2899725573,
        1.053651024, -0.0001550523, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.10097082157493222, 0.0011886190124615608],
    },
  },
  '60-x-40__natural-floating-frame': {
    revision: '80066751107d0061',
    sideWrap: {
      inverse: [
        213.6334664013, -0.02328063, -42.626046136, 0.7100221248, 2.2858079484, -0.6533403521,
        1.3084870512, -0.0002843112, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.1403144547021081, 0.001501411927598999],
    },
  },
  '60-x-40__white-floating-frame': {
    revision: '46ccda7891168c49',
    sideWrap: {
      inverse: [
        213.6357588077, -0.023266951, -42.6265104979, 0.7100381219, 2.2858263326, -0.6533476972,
        1.3085367005, -0.0002841519, 1,
      ],
      depth: 0.020833333333333332,
      feather: [0.14031482506644616, 0.0015014118021163586],
    },
  },
  '8-x-10__black-floating-frame': {
    revision: '03c2a4a2ee87a8e3',
    sideWrap: {
      inverse: [
        65.4407601322, -0.0060835186, -25.2189196975, 0.4432086883, 2.7606939752, -0.8873871158,
        0.8452628185, -0.0001561402, 1,
      ],
      depth: 0.15625,
      feather: [0.04060466425640722, 0.0017130030311491723],
    },
  },
  '8-x-10__espresso-floating-frame': {
    revision: '5afeac662957b3dc',
    sideWrap: {
      inverse: [
        71.9919097415, -0.0067107185, -27.7435341241, 0.4875698002, 3.0370391002, -0.9762128733,
        1.1765316795, -0.0002175476, 1,
      ],
      depth: 0.15625,
      feather: [0.04060465962146945, 0.0017130030543319828],
    },
  },
  '8-x-10__gallery-wrapped-canvas': {
    revision: 'f4a60fabedb597b4',
    sideWrap: {
      inverse: [
        28.4535089597, 0.002469716, -5.407406038, 0.4971632185, 1.4887437676, -0.2497159001,
        0.9667104763, 0.0001649667, 1,
      ],
      depth: 0.15625,
      feather: [0.019349944780494198, 0.0010123712449499748],
    },
  },
  '8-x-10__natural-floating-frame': {
    revision: '388aad284126c6f5',
    sideWrap: {
      inverse: [
        65.4609580132, -0.0060838552, -25.2270108889, 0.4433456321, 2.7609141859, -0.8874991337,
        0.8455268328, -0.0001561494, 1,
      ],
      depth: 0.15625,
      feather: [0.04061395604871893, 0.0017130029899439679],
    },
  },
  '8-x-10__white-floating-frame': {
    revision: '952e0c4e313c6527',
    sideWrap: {
      inverse: [
        67.9173611787, -0.0063335752, -26.116725542, 0.4599785961, 2.9814923418, -0.9507781518,
        1.1099431504, -0.0002053214, 1,
      ],
      depth: 0.15625,
      feather: [0.039020269931754045, 0.0017130030509947326],
    },
  },
  '8-x-8__black-floating-frame': {
    revision: 'ede37c1280c68729',
    sideWrap: {
      inverse: [
        69.0214637526, 0.0115067573, -26.6077698985, 0.4859524358, 3.6267594153, -1.3029778488,
        1.0163401974, 0.0003363791, 1,
      ],
      depth: 0.15625,
      feather: [0.040715358154097825, 0.0021393049094553173],
    },
  },
  '8-x-8__espresso-floating-frame': {
    revision: '561563d8a9f161c4',
    sideWrap: {
      inverse: [
        69.0215369395, 0.01150731, -26.6077983821, 0.4859549038, 3.6267622969, -1.3029797073,
        1.0163429909, 0.0003363958, 1,
      ],
      depth: 0.15625,
      feather: [0.0407153685594041, 0.002139304882663347],
    },
  },
  '8-x-8__natural-floating-frame': {
    revision: '914078965c752cb1',
    sideWrap: {
      inverse: [
        69.0748038474, 0.0115163053, -26.6291063742, 0.4863220506, 3.6275774024, -1.3033773327,
        1.017124725, 0.0003366579, 1,
      ],
      depth: 0.15625,
      feather: [0.040737636519029945, 0.002139304923536751],
    },
  },
  '8-x-8__white-floating-frame': {
    revision: '8b0158cb7e3646d3',
    sideWrap: {
      inverse: [
        73.6133845476, 0.0123249648, -28.3166266284, 0.5182886061, 4.0255796798, -1.4376954523,
        1.3989024143, 0.0004639842, 1,
      ],
      depth: 0.15625,
      feather: [0.03912245852799186, 0.0021393048832417634],
    },
  },
  '9-x-12__black-floating-frame': {
    revision: 'ea75833f86dd1329',
    sideWrap: {
      inverse: [
        52.7324373765, 0.003011286, -14.8764518534, 0.5661846943, 1.8833612403, -0.4563864792,
        1.0482493719, 0.0001185305, 1,
      ],
      depth: 0.1388888888888889,
      feather: [0.03323943592516067, 0.0011871231427862158],
    },
  },
  '9-x-12__espresso-floating-frame': {
    revision: '21eab6075aeb3745',
    sideWrap: {
      inverse: [
        52.7325230958, 0.0030108532, -14.8764758163, 0.5661890213, 1.8833644069, -0.4563882402,
        1.0482568846, 0.0001185141, 1,
      ],
      depth: 0.1388888888888889,
      feather: [0.0332394320744893, 0.001187123076742484],
    },
  },
  '9-x-12__gallery-wrapped-canvas': {
    revision: '8617cf4ad0a749e1',
    sideWrap: {
      inverse: [
        34.3270428432, 0.0013795455, -8.324999543, 0.497001352, 1.5477468984, -0.2787071078,
        0.971582664, 0.0000769873, 1,
      ],
      depth: 0.1388888888888889,
      feather: [0.02249525962271939, 0.0010142470702421363],
    },
  },
  '9-x-12__natural-floating-frame': {
    revision: 'fc5a7a4ada7185f9',
    sideWrap: {
      inverse: [
        63.7091118322, 0.0009488826, -23.5463180403, 0.2921497962, 2.2389920096, -0.5950779241,
        0.7030913586, 0.0000208281, 1,
      ],
      depth: 0.1388888888888889,
      feather: [0.04167524750780132, 0.0014646274144512479],
    },
  },
  '9-x-12__white-floating-frame': {
    revision: 'd9d22a6d2a67046c',
    sideWrap: {
      inverse: [
        52.4258540178, 0.0030016207, -14.745913719, 0.5628933042, 1.9351678954, -0.4631455093,
        1.1666198071, 0.0001321024, 1,
      ],
      depth: 0.1388888888888889,
      feather: [0.032161587539564544, 0.0011871231772357198],
    },
  },
};
